"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseProviderImpl = void 0;
var Future_1 = require("../../../utils/Future");
var FirebaseApp_1 = require("../../firebase/FirebaseApp");
var app_1 = require("firebase/app");
var Utils_1 = require("../../../utils/Utils");
var FirebaseUtils_1 = require("../../firebase/FirebaseUtils");
var uuid_1 = require("uuid");
var jssoup_1 = require("jssoup");
var uuid_2 = require("uuid");
var Request_1 = require("../../../utils/Request");
var UserCache_1 = require("../../UserCache");
var Settings_1 = require("../../Settings");
var DataSyncProviderImpl_1 = require("./DataSyncProviderImpl");
var CoreServiceHelper_1 = require("../airabbi/CoreServiceHelper");
var CourseProviderImpl = (function () {
    function CourseProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.unitCourses = [];
        this.hybrid = true;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " CourseProviderImpl#")], args, false));
            }
        };
        this.pushIntoUnitCoursesCache = function (courses, unit) {
            if (!courses) {
                return;
            }
            var idx = _this.unitCourses.findIndex(function (obj) { return obj.unit === unit; });
            if (idx !== -1) {
                _this.unitCourses.splice(idx, 1);
            }
            _this.unitCourses.push({
                unit: unit,
                courses: courses
            });
        };
        this.updateAllExercisesInCourse = function (promiseTemps, course, lessons, exercise, lessonType) {
            lessons.forEach(function (lesson, lessonIndex) {
                var exercises = lesson.exercises;
                var offlineExercises = lesson.offlineExercises;
                if (exercises) {
                    exercises.forEach(function (exerciseInDb, exerciseIndex) {
                        if (exerciseInDb && exerciseInDb.id === exercise.id) {
                            promiseTemps.push(new Promise(function (resolve1, reject) {
                                resolve1(_this.updateExerciseInCourse(course, lessonIndex, exerciseIndex, exercise, 'online', lessonType));
                            }));
                        }
                    });
                }
                if (offlineExercises) {
                    offlineExercises.forEach(function (exerciseInDb, exerciseIndex) {
                        if (exerciseInDb && exerciseInDb.id === exercise.id) {
                            promiseTemps.push(new Promise(function (resolve2, reject) {
                                resolve2(_this.updateExerciseInCourse(course, lessonIndex, exerciseIndex, exercise, 'offline', lessonType));
                            }));
                        }
                    });
                }
            });
        };
        this.updateExerciseInCourse = function (course, lessonIndex, exerciseIndex, exercise, exerciseType, lessonType) {
            var currentUser = (0, UserCache_1.loadUser)();
            var promiseTemps2 = [];
            var mongoDbUpdateObj = {};
            delete exercise.inClass;
            delete exercise.isShowAnswer;
            delete exercise.isShowContent;
            delete exercise.isShowTip;
            delete exercise.shareable;
            Object.keys(exercise).forEach(function (key) {
                if (exerciseType === 'online') {
                    mongoDbUpdateObj["".concat(lessonType, ".").concat(lessonIndex, ".exercises.").concat(exerciseIndex, ".").concat(key)] =
                        exercise[key];
                }
                else {
                    mongoDbUpdateObj["".concat(lessonType, ".").concat(lessonIndex, ".offlineExercises.").concat(exerciseIndex, ".").concat(key)] =
                        exercise[key];
                }
            });
            var fbUpdatePath = exerciseType === 'online'
                ? "/units/".concat(currentUser.unit, "/courses/").concat(course.id, "/").concat(lessonType, "/").concat(lessonIndex, "/exercises/").concat(exerciseIndex)
                : "/units/".concat(currentUser.unit, "/courses/").concat(course.id, "/").concat(lessonType, "/").concat(lessonIndex, "/offlineExercises/").concat(exerciseIndex);
            promiseTemps2.push(new Promise(function (resolve2, reject2) { return resolve2((0, FirebaseUtils_1.updateNode)(fbUpdatePath, exercise)); }));
            return Promise.all(promiseTemps2);
        };
        this.syncExerciseIntoCourses = function (exercise) {
            if (!exercise || !exercise.id || exercise.id === '') {
                return Promise.reject('Incorrect exercise! no exercise id');
            }
            _this.log('syncExerciseIntoCourses# exercise id: ', exercise.id, 'content: ', exercise.content);
            var promiseTemps = [];
            return _this.getMyCourses()
                .then(function (courses) {
                courses.forEach(function (course) {
                    var lessons = course.lessons;
                    var tests = course.tests;
                    if (lessons) {
                        _this.updateAllExercisesInCourse(promiseTemps, course, lessons, exercise, 'lessons');
                    }
                    if (tests) {
                        _this.updateAllExercisesInCourse(promiseTemps, course, tests, exercise, 'tests');
                    }
                });
                return Promise.resolve(Promise.all(promiseTemps));
            })
                .catch(function (err) { return Promise.reject(err); });
        };
        this.isInCourse = function (course, user) {
            if (!course || !user) {
                return false;
            }
            if (user.role === 'teacher' && course.teachers) {
                return course.teachers.findIndex(function (t) { return t.uid === user.uid; }) !== -1;
            }
            if (user.role === 'student' && course.students) {
                return course.students.findIndex(function (s) { return s.uid === user.uid; }) !== -1;
            }
            return false;
        };
        this.updateFile = function (uid, filename, code) {
            if (!uid || uid === '' || !filename || filename === '') {
                return Promise.reject('Incorrect data');
            }
            var rootPath = "files/".concat(uid, "/files");
            var newKey = FirebaseApp_1.FirebaseApp.GET().firebase.database().ref(rootPath).push().key;
            var file = {
                id: newKey,
                name: filename,
                code: code,
                timestamp: app_1.default.database.ServerValue.TIMESTAMP
            };
            var future = new Future_1.Future(Future_1.futureFunc);
            (0, FirebaseUtils_1.updateNode)("".concat(rootPath, "/").concat(newKey), file)
                .then(function () {
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
            return future.promise;
        };
        this.syncExerciseIntoTests = function (exercise) {
            if (!exercise || !exercise.id || exercise.id === '') {
                return Promise.reject('Incorrect exercise! no exercise id');
            }
            var currentUser = (0, UserCache_1.loadUser)();
            return _this.getTests(currentUser.uid)
                .then(function (tests) {
                var promises = [];
                tests.forEach(function (test) {
                    test.exercises.forEach(function (ex, idx) {
                        if (ex.id === exercise.id) {
                            test.exercises[idx] = exercise;
                            promises.push(_this.updateTest(__assign({}, test)));
                        }
                    });
                });
                return Promise.resolve(Promise.all(promises));
            })
                .catch(function (err) { return Promise.reject(err); });
        };
        this.log('CourseProviderImpl# created!');
        this.dataSyncProvider = new DataSyncProviderImpl_1.DataSyncProviderImpl(cfg);
    }
    CourseProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    CourseProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    CourseProviderImpl.prototype.setCourseData = function (courseId, path, value) {
        if (!this.hybrid) {
            return Promise.resolve();
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).setData('courses', { id: courseId }, path, value);
    };
    CourseProviderImpl.prototype.createCourseData = function (course) {
        var _this = this;
        if (!this.hybrid) {
            return Promise.resolve();
        }
        course.updated = Date.now();
        if (course.teachers) {
            course.teachers.forEach(function (t) {
                delete t.updated;
            });
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .removeData('courses', { id: course.id, unit: course.unit })
            .then(function () {
            _this.log('delete course successfully');
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).createData('courses', course);
        })
            .catch(function (err) {
            _this.log(err);
        });
    };
    CourseProviderImpl.prototype.updateCourseData = function (course) {
        if (!this.hybrid) {
            return Promise.resolve();
        }
        course.updated = Date.now();
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).updateData('courses', { id: course.id, unit: course.unit }, course);
    };
    CourseProviderImpl.prototype.removeCourseDataByUnit = function (unit, courseId) {
        if (!this.hybrid) {
            return Promise.resolve();
        }
        this.log('removeCourseDataByUnit#', "".concat(unit, "/").concat(courseId));
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).removeData('courses', {
            id: courseId,
            unit: unit
        });
    };
    CourseProviderImpl.prototype.queryCoursesData = function () {
        if (!this.hybrid) {
            return Promise.resolve();
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('courses', {}, {}, {}, '')
            .then(function (response) {
            return response.result ? response.result : undefined;
        });
    };
    CourseProviderImpl.prototype.queryCourseData = function (filter) {
        if (!this.hybrid) {
            return Promise.resolve();
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('courses', filter, {}, {}, '')
            .then(function (response) {
            return response.result ? response.result : undefined;
        });
    };
    CourseProviderImpl.prototype.queryCourseDataByUnit = function (unit, courseId) {
        if (!this.hybrid) {
            return Promise.resolve();
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('courses', { id: courseId, unit: unit }, {}, {}, '')
            .then(function (response) {
            return response.result ? response.result[0] : undefined;
        });
    };
    CourseProviderImpl.prototype.getCourseFilterProjection = function () {
        return {
            'students.photoUrl': false,
            'teachers.photoUrl': false,
            'lessons.materialInfo': false,
            'lessons.openList': false,
            'lessons.exercises.title': false,
            'lessons.exercises.content': false,
            'lessons.exercises.tips': false,
            'lessons.exercises.answers': false,
            'lessons.exercises.vds': false,
            'lessons.offlineExercises.title': false,
            'lessons.offlineExercises.content': false,
            'lessons.offlineExercises.tips': false,
            'lessons.offlineExercises.answers': false,
            'lessons.offlineExercises.vds': false,
            'tests.exercises.title': false,
            'tests.exercises.content': false,
            'tests.exercises.tips': false,
            'tests.exercises.answers': false,
            'tests.exercises.vds': false
        };
    };
    CourseProviderImpl.prototype.queryCoursesDataByUnit = function (unit) {
        if (!this.hybrid) {
            return Promise.resolve();
        }
        var user = (0, UserCache_1.loadUser)();
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('courses', { unit: unit }, {}, this.getCourseFilterProjection(), '')
            .then(function (response) {
            return response.result ? response.result : undefined;
        });
    };
    CourseProviderImpl.prototype.queryCoursesDataByUser = function (user) {
        if (!this.hybrid || !user) {
            return Promise.resolve(undefined);
        }
        var filter = {
            unit: user.unit,
            'teachers.uid': user.uid,
            'students.uid': user.uid
        };
        if (user.role === 'teacher') {
            delete filter['students.uid'];
        }
        else {
            delete filter['teachers.uid'];
        }
        var projection = this.getCourseFilterProjection();
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('courses', filter, {}, projection, '')
            .then(function (response) {
            return response.result ? response.result : undefined;
        });
    };
    CourseProviderImpl.prototype.getCourseInfo = function (course) {
        if (!course) {
            return course;
        }
        var lessons = course.lessons ? course.lessons.sort(function (a, b) { return a.beginTime - b.beginTime; }) : [];
        var beginTime = course.beginTime;
        var endTime = course.endTime;
        if (lessons && lessons.length > 0) {
            beginTime = lessons[0].beginTime;
            endTime = lessons[lessons.length - 1].endTime;
        }
        return {
            id: course.id,
            cid: course.cid,
            order: course.order,
            title: course.title,
            timeInfo: course.timeInfo,
            teachers: course.teachers ? course.teachers.length : 0,
            students: course.students ? course.students.length : 0,
            startTime: beginTime,
            beginTime: beginTime,
            endTime: endTime,
            content: course.content,
            lessons: course.lessons ? course.lessons : 0,
            photoURL: course.photoURL ? course.photoURL : '',
            unit: course.unit,
            language: course.language,
            level: course.level,
            isAddByCode: course.isAddByCode,
            code: course.code,
            tests: course.tests ? course.tests.length : 0,
            status: course.status,
            updated: course.updated
        };
    };
    CourseProviderImpl.prototype.hasEmptyExercise = function (lesson) {
        if (lesson.exercises && lesson.exercises.find(function (e) { return e.id === undefined; })) {
            return true;
        }
        if (lesson.offlineExercises &&
            lesson.offlineExercises.find(function (e) { return e.id === undefined; })) {
            return true;
        }
        return false;
    };
    CourseProviderImpl.prototype.hasEmptyExercises = function (course) {
        var _this = this;
        if (course.lessons && course.lessons.find(function (lesson) { return _this.hasEmptyExercise(lesson); })) {
            return true;
        }
        return false;
    };
    CourseProviderImpl.prototype.createCourse = function (course) {
        var _this = this;
        if (!course || !course.id || course.id === '') {
            return Promise.reject('createCourse# error! Incorrect course!');
        }
        if (this.hasEmptyExercises(course)) {
            return Promise.reject('createCourse# error! course has empty exercises');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        this.log('createCourse, course:', course);
        return this.convertImgBinaryStr2Link(course).then(function (updatedCourse) {
            return _this.createCourseByUnit(updatedCourse, currentUser.unit);
        });
    };
    CourseProviderImpl.prototype.createCourseByUnit = function (course, unit) {
        var _this = this;
        if (!course || !course.id || course.id === '' || !unit || unit === '') {
            return Promise.reject('createCourseByUnit# error! Incorrect course!');
        }
        if (this.hasEmptyExercises(course)) {
            return Promise.reject('createCourseByUnit# error! course has empty exercises');
        }
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createCourseEvent('create', course);
        var promises = [];
        course.unit = unit;
        promises.push((0, FirebaseUtils_1.updateNode)("/units/".concat(unit, "/courses/").concat(course.id), course));
        promises.push(this.createCourseData(course));
        return Promise.all(promises).then(function (results) {
            _this.log('createCourseByUnit, results:', results);
            _this.clearCourseCache();
            return Promise.resolve();
        });
    };
    CourseProviderImpl.prototype.getAllCoursesFromLocal = function () {
        this.log('getAllCoursesFromLocal <<<');
        return [];
    };
    CourseProviderImpl.prototype.getMyCourses = function () {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        this.log('getMyCourses#');
        if (this.myUid && this.myUid === currentUser.uid && this.myCourses) {
            this.log('getMyCourses#, courses[cache]:', this.myCourses);
            return Promise.resolve(this.myCourses);
        }
        if (this.hybrid) {
            return this.queryCoursesDataByUser(currentUser).then(function (courses) {
                var myCourses = courses ? courses.reverse() : [];
                _this.updateMyCoursesCache(currentUser.uid, myCourses);
                _this.log('getMyCourses#, courses[api]:', _this.myCourses);
                return Promise.resolve(myCourses);
            });
        }
        return (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/courses")).then(function (snapshot) {
            var courses = [];
            snapshot.forEach(function (childSnapshot) {
                courses.push(childSnapshot.val());
            });
            if (courses) {
                courses = courses.filter(function (course) { return _this.isInCourse(course, currentUser); });
                courses = courses.reverse();
            }
            _this.updateMyCoursesCache(currentUser.uid, courses);
            _this.log('getMyCourses#, courses[fb]:', courses);
            return Promise.resolve(courses);
        });
    };
    CourseProviderImpl.prototype.getMyUnitCourses = function () {
        var _this = this;
        this.log('getMyUnitCourses# <<<');
        var currentUser = (0, UserCache_1.loadUser)();
        var unitCourses = this.unitCourses.find(function (obj) { return obj.unit === currentUser.unit; });
        if (unitCourses) {
            this.log('getMyUnitCourses# courses[cache]:', unitCourses);
            return Promise.resolve(unitCourses.courses);
        }
        if (this.hybrid) {
            return this.queryCoursesDataByUser(currentUser).then(function (courses) {
                _this.pushIntoUnitCoursesCache(courses ? courses.reverse() : [], currentUser.unit);
                _this.log('getMyUnitCourses# courses[api]:', courses);
                return Promise.resolve(courses ? courses.reverse() : []);
            });
        }
        return (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/courses")).then(function (snapshot) {
            var courses = (0, Utils_1.objectToList)(snapshot.val());
            _this.log('getMyUnitCourses# courses[fb]:', courses);
            courses = courses ? courses.reverse() : [];
            _this.pushIntoUnitCoursesCache(courses, currentUser.unit);
            return Promise.resolve(courses);
        });
    };
    CourseProviderImpl.prototype.getMyUnitCoursesWithoutHybird = function () {
        var _this = this;
        this.log('getMyUnitCoursesWithoutHybird# <<<');
        var currentUser = (0, UserCache_1.loadUser)();
        return (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/courses")).then(function (snapshot) {
            var courses = (0, Utils_1.objectToList)(snapshot.val());
            _this.log('getMyUnitCourses# courses[fb]:', courses);
            courses = courses ? courses.reverse() : [];
            _this.pushIntoUnitCoursesCache(courses, currentUser.unit);
            return Promise.resolve(courses);
        });
    };
    CourseProviderImpl.prototype.clearCourseCache = function () {
        this.myUid = undefined;
        this.myCourses = undefined;
        this.unitCourses = [];
    };
    CourseProviderImpl.prototype.getCoursesByUnit = function (unit) {
        var _this = this;
        this.log('getCoursesByUnit# <<<');
        if (!unit || unit.trim().length === 0) {
            return Promise.reject('unit cannot be empty');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        if (!currentUser || currentUser.role !== 'staff') {
            return Promise.reject('getCoursesByUnit() permission denied!');
        }
        var unitCourses = this.unitCourses.find(function (obj) { return obj.unit === unit; });
        if (unitCourses) {
            return Promise.resolve(unitCourses.courses);
        }
        if (this.hybrid) {
            return this.queryCoursesDataByUnit(unit).then(function (courses) {
                _this.unitCourses.push({ unit: unit, courses: courses ? courses.reverse() : [] });
                return Promise.resolve(courses);
            });
        }
        return (0, FirebaseUtils_1.getNode)("/units/".concat(unit, "/courses")).then(function (snapshot) {
            var courses = [];
            snapshot.forEach(function (childSnapshot) {
                var obj = childSnapshot.val();
                courses.push(obj);
            });
            if (courses) {
                courses = courses.reverse();
                _this.log('getCoursesByUnit# courses:', courses.length);
            }
            return Promise.resolve(courses);
        });
    };
    CourseProviderImpl.prototype.getMyUnitCoursesByPagination = function (sort, skip, limit, searchString, classType) {
        return Promise.reject('implement in the future');
    };
    CourseProviderImpl.prototype.getCoursesByUnitByPagination = function (unit, sort, skip, limit, searchString) {
        return Promise.reject('implement in the future');
    };
    CourseProviderImpl.prototype.getAllCoursesByPagination = function (sort, skip, limit, searchString) {
        return Promise.reject('implement in the future');
    };
    CourseProviderImpl.prototype.fetchAllCoursesByStudent = function (email, sortBy, projection) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (currentUser.role !== 'staff' && currentUser.uid !== 'developer-airabbi-com') {
            return Promise.reject('fetchAllCoursesByStudent# error! Permission denied!');
        }
        if (!email) {
            return Promise.reject('fetchAllCoursesByStudent# uid cannot be empty!');
        }
        if (this.hybrid) {
            var uid = (0, Utils_1.email2UID)(email);
            var filter = {
                'students.uid': uid
            };
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
                .queryData('courses', filter, {}, {}, '')
                .then(function (response) {
                return response && response.result ? response.result : [];
            });
        }
        else {
            return Promise.reject('not implement yet');
        }
    };
    CourseProviderImpl.prototype.getCourses = function () {
        this.log('getCourses# <<<');
        return this.getMyUnitCourses();
    };
    CourseProviderImpl.prototype.getCourseByCid = function (cid) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (this.hybrid) {
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
                .queryOne('courses', {
                cid: cid,
                unit: currentUser.unit
            }, {})
                .then(function (res) {
                return res && res.result ? res.result : undefined;
            });
        }
        return (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/courses")).then(function (snapshot) {
            var courses = (0, Utils_1.objectToList)(snapshot.val());
            var courseFilter = courses.filter(function (c) { return c.cid && c.cid === cid; });
            return courseFilter ? courseFilter[0] : undefined;
        });
    };
    CourseProviderImpl.prototype.getTests = function (uid) {
        var _this = this;
        this.log('getTests# <<<');
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/tests/").concat(uid))
            .then(function (snapshot) {
            var tests = [];
            snapshot.forEach(function (childSnapshot) {
                var obj = childSnapshot.val();
                _this.log('getTests#, obj:', obj);
                tests.push(obj);
            });
            _this.log('getTests#, tests:', tests);
            future.resolve(tests);
        })
            .catch(function (err) {
            _this.log("getTests#, error", err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getMyTestsByPagination = function (codeType, skip, limit, sort, searchString) {
        return Promise.resolve({
            result: [],
            totalCount: 0
        });
    };
    CourseProviderImpl.prototype.getCourse = function (id) {
        var _this = this;
        if (!id || id === '') {
            return Promise.reject('getCourse# error! Incorrect id!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        return (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/courses/").concat(id)).then(function (snapshot) {
            var obj = snapshot.val();
            _this.log('getCourse, course:', obj);
            return Promise.resolve(obj);
        });
    };
    CourseProviderImpl.prototype.getCourseByUnit = function (id, unit) {
        var _this = this;
        if (!id || id === '' || !unit || unit === '') {
            return Promise.reject('getCourseByUnit# error! Incorrect id or unit!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        if (!currentUser || (currentUser.role !== 'staff' && currentUser.role !== 'admin')) {
            return Promise.reject('getCourseByUnit# error! Permission denied!');
        }
        return (0, FirebaseUtils_1.getNode)("/units/".concat(unit, "/courses/").concat(id)).then(function (snapshot) {
            var obj = snapshot.val();
            _this.log('getCourseByUnit, course:', obj);
            return Promise.resolve(obj);
        });
    };
    CourseProviderImpl.prototype.removeCourse = function (id) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createCourseEvent('remove', { id: id });
        this.removeCourseDataByUnit(currentUser.unit, id)
            .then(function () {
            _this.log('removeCourse#removeCourseDataByUnit#', 'remove ' + id + ' successfully!');
        })
            .catch(function (err) { return _this.log(err); });
        this.clearCourseCache();
        var path = "/units/".concat(currentUser.unit, "/courses/").concat(id);
        return (0, FirebaseUtils_1.removeNode)(path);
    };
    CourseProviderImpl.prototype.removeShareCourse = function (id, shareType) {
        var currentUser = (0, UserCache_1.loadUser)();
        var path;
        if (shareType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/courses/").concat(id);
        }
        else if (shareType === 'public') {
            path = "/units/sharedResources/courses/".concat(id);
        }
        else {
            return Promise.reject('this share type not support!');
        }
        return (0, FirebaseUtils_1.getNode)(path).then(function (snapshot) {
            var courseObj = snapshot.val();
            if (!courseObj) {
                return Promise.reject('shared course not exist!');
            }
            var teacherList = courseObj.teachers;
            if (!teacherList || !teacherList.find(function (teacher) { return teacher.uid === currentUser.uid; })) {
                return Promise.reject('owner is wrong!');
            }
            return (0, FirebaseUtils_1.removeNode)(path);
        });
    };
    CourseProviderImpl.prototype.removeUnitCourse = function (unit, id) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (currentUser.role !== 'staff') {
            return Promise.reject('Permission denied!');
        }
        if (!unit || unit.trim().length === 0 || !id || id.trim().length === 0) {
            return Promise.reject('Invalid data!');
        }
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createCourseEvent('remove', { id: id });
        this.removeCourseDataByUnit(unit, id)
            .then(function () {
            _this.log('removeUnitCourse#removeCourseDataByUnit#', 'remove ' + id + ' successfully!');
        })
            .catch(function (err) { return _this.log(err); });
        var path = "/units/".concat(unit, "/courses/").concat(id);
        return (0, FirebaseUtils_1.removeNode)(path);
    };
    CourseProviderImpl.prototype.changeToImageFile = function (imgType, base64Data, imgs, imgIndex) {
        var bitmap = atob(base64Data);
        var arr = [];
        for (var i = 0; i < bitmap.length; i++) {
            arr.push(bitmap.charCodeAt(i));
        }
        var u8 = new Uint8Array(arr);
        var imgFile = new Blob([u8], { type: imgType });
        var form = new FormData();
        var fileName = (0, uuid_2.v4)() + ".".concat(imgType);
        imgs[imgIndex].attrs.src = 'https://file.codingbar.ai/file/public?name=' + fileName;
        this.log('changeToImageFile# public img: ', imgs[imgIndex].attrs.src);
        form.append('file', imgFile, fileName);
        return fetch('https://file.codingbar.ai/file/uploadPublicFile', {
            method: 'POST',
            body: form,
            cache: 'no-cache',
            mode: 'cors',
            redirect: 'follow',
            referrer: 'no-referrer'
        });
    };
    CourseProviderImpl.prototype.convertImgBinaryStr2Link = function (course) {
        var _this = this;
        var lessons = course.lessons && Array.isArray(course.lessons) ? course.lessons : [];
        var exercisePromises = [];
        var _loop_1 = function (lessonIndex) {
            var lesson = lessons[lessonIndex];
            var exercises = lesson.exercises && Array.isArray(lesson.exercises) ? lesson.exercises : [];
            var _loop_2 = function (exerciseIndex) {
                exercisePromises.push(new Promise(function (resolve1, reject) {
                    var changeImgPromises = [];
                    var exercise = exercises[exerciseIndex];
                    var content = exercise.content;
                    var htmlParser = new jssoup_1.default(content);
                    var imgs = htmlParser.findAll('img');
                    for (var _i = 0, _a = Object.keys(imgs); _i < _a.length; _i++) {
                        var imgIndex = _a[_i];
                        var source = imgs[imgIndex].attrs.src;
                        if (!source.includes('data:image/png') &&
                            !source.includes('data:image/jpeg') &&
                            !source.includes('data:image/gif')) {
                            continue;
                        }
                        var base64Data = source.split(',')[1];
                        if (source && source.includes('data:image/png')) {
                            changeImgPromises.push(_this.changeToImageFile('png', base64Data, imgs, imgIndex));
                        }
                        else if (source && source.includes('data:image/jpeg')) {
                            changeImgPromises.push(_this.changeToImageFile('jpeg', base64Data, imgs, imgIndex));
                        }
                        else if (source && source.includes('data:image/gif')) {
                            changeImgPromises.push(_this.changeToImageFile('gif', base64Data, imgs, imgIndex));
                        }
                    }
                    Promise.all(changeImgPromises)
                        .then(function () {
                        exercise.content = htmlParser.prettify();
                        resolve1({});
                    })
                        .catch(reject);
                }));
            };
            for (var _b = 0, _c = Object.keys(exercises); _b < _c.length; _b++) {
                var exerciseIndex = _c[_b];
                _loop_2(exerciseIndex);
            }
        };
        for (var _i = 0, _a = Object.keys(lessons); _i < _a.length; _i++) {
            var lessonIndex = _a[_i];
            _loop_1(lessonIndex);
        }
        return Promise.all(exercisePromises).then(function () { return course; });
    };
    CourseProviderImpl.prototype.updateCourse = function (course) {
        var _this = this;
        if (!course || !course.id || course.id === '') {
            return Promise.reject('updateCourse# error! Incorrect course!');
        }
        if (this.hasEmptyExercises(course)) {
            return Promise.reject('updateCourse# error! course has empty exercises');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        if (course.teachers && course.teachers.length > 0) {
            course.teachers.forEach(function (t) {
                delete t.others;
            });
        }
        if (course.students && course.students.length > 0) {
            course.students.forEach(function (t) {
                delete t.others;
            });
        }
        if (course.students) {
            course.students.forEach(function (s) {
                delete s.others;
            });
        }
        course.unit = currentUser.role === 'teacher' ? currentUser.unit : course.unit;
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createCourseEvent('update', course);
        return this.convertImgBinaryStr2Link(course)
            .then(function (updatedCourse) {
            _this.updateCourseData(updatedCourse)
                .then(function () {
                _this.log('updateCourse#updateCourseData#', updatedCourse);
            })
                .catch(function (err) { return _this.log(err); });
            _this.clearCourseCache();
            var promises = [];
            promises.push((0, FirebaseUtils_1.updateNode)("/units/".concat(updatedCourse.unit, "/courses/").concat(updatedCourse.id), updatedCourse));
            return Promise.all(promises).then(function (results) {
                _this.log('updateCourseData, results:', results);
                _this.clearCourseCache();
                return Promise.resolve();
            });
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.updateMyCoursesCache = function (uid, courses) {
        this.myUid = uid;
        this.myCourses = courses ? courses : [];
    };
    CourseProviderImpl.prototype.searchCourse = function (filter) {
        return Promise.reject('searchCourse() API is not implemented!');
    };
    CourseProviderImpl.prototype.getStudentStatsByOnlineExercises = function (courseId, studentId) {
        return Promise.resolve();
    };
    CourseProviderImpl.prototype.getStudentStats = function (courseId, studentId) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || !studentId) {
            return Promise.reject('getStudentStatis# error! courseId and studentId cannot be blank!');
        }
        studentId = studentId.replace(/[&\/\\#,+()$~%.@'":*?<>{}]/g, '-');
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/"))
            .then(function (snapshot) {
            var returnObj = {
                courseId: courseId,
                student: {
                    finishCount: 0,
                    totalSec: 0,
                    tipViewCount: 0
                },
                allStudent: {
                    finishCount: 0,
                    avgTotalSec: 0,
                    tipViewCount: 0
                }
            };
            var totalStudentCount = 0;
            snapshot.forEach(function (childSnapshot) {
                childSnapshot.forEach(function (grandChildSnapshot) {
                    grandChildSnapshot.forEach(function (greatGrandChildSnapshot) {
                        var dbStudentId = greatGrandChildSnapshot.key;
                        var obj = greatGrandChildSnapshot.val();
                        if (dbStudentId === studentId) {
                            if (obj.codeStatus) {
                                if (obj.codeStatus === 'finished') {
                                    returnObj.student.finishCount += 1;
                                }
                            }
                            else {
                                if (obj.status === 'finished') {
                                    returnObj.student.finishCount += 1;
                                }
                            }
                            if (obj.duration) {
                                returnObj.student.totalSec += obj.duration;
                            }
                            if (obj.tipViewCount) {
                                returnObj.student.tipViewCount += obj.tipViewCount;
                            }
                        }
                        if (obj.codeStatus) {
                            if (obj.codeStatus === 'finished') {
                                returnObj.allStudent.finishCount += 1;
                            }
                        }
                        else {
                            if (obj.status === 'finished') {
                                returnObj.allStudent.finishCount += 1;
                            }
                        }
                        if (obj.duration) {
                            returnObj.allStudent.avgTotalSec += obj.duration;
                        }
                        if (obj.tipViewCount) {
                            returnObj.allStudent.tipViewCount += obj.tipViewCount;
                        }
                        totalStudentCount += 1;
                    });
                });
            });
            returnObj.allStudent.avgTotalSec =
                returnObj.allStudent.avgTotalSec / totalStudentCount / 1000;
            returnObj.allStudent.avgTotalSec = Math.round(returnObj.allStudent.avgTotalSec);
            returnObj.student.totalSec /= 1000;
            returnObj.student.totalSec = Math.round(returnObj.student.totalSec);
            future.resolve(returnObj);
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.updateProperty = function (id, propName, value) {
        var currentUser = (0, UserCache_1.loadUser)();
        return (0, FirebaseUtils_1.setNode)("/units/".concat(currentUser.unit, "/courses/").concat(id, "/").concat(propName), value);
    };
    CourseProviderImpl.prototype.getStudentStatusList = function (courseId, lessonId, exerciseId) {
        var _this = this;
        this.log('getStudentStatusList <<<');
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/"))
            .then(function (snapshot) {
            var studentStatusList = [];
            snapshot.forEach(function (childSnapshot) {
                var obj = childSnapshot.val();
                _this.log('getStudentStatusList, obj:', obj);
                studentStatusList.push(obj);
                return false;
            });
            _this.log('getStudentStatusList, studentStatusList:', studentStatusList);
            future.resolve(studentStatusList);
        })
            .catch(function (err) {
            _this.log("getStudentStatusList, error", err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getStudentStatusByCourseWithSpecificExerciseIds = function (courseId, lessonId, exerciseIds, uid) {
        var _this = this;
        this.log('getStudentStatusByCourse <<<');
        if (!courseId || courseId === '') {
            return Promise.reject('getStudentStatusByCourse# courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('getStudentStatusByCourse# lessonId cannot be empty!');
        }
        if (!exerciseIds || exerciseIds.length === 0) {
            return Promise.reject('getStudentStatusByCourse# exerciseIds cannot be empty!');
        }
        if (!uid || uid === '') {
            return Promise.reject('getStudentStatusByCourse# studentStatusId cannot be empty!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        var promiseTemps = exerciseIds.map(function (exerciseId) {
            return new Promise(function (resolve2, reject) {
                _this.getStudentStatus(courseId, lessonId, exerciseId, uid)
                    .then(resolve2)
                    .catch(function (err) {
                    _this.log('getStudentStatusByCourse# get student status err: ', err);
                    resolve2(undefined);
                });
            });
        });
        Promise.all(promiseTemps)
            .then(function (studentStatusList) {
            _this.log('getStudentStatusByCourse# studentStatusList: ', studentStatusList);
            future.resolve(studentStatusList);
        })
            .catch(function (err) {
            _this.log("getStudentStatusByCourse#, total errors: ", err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getStudentStatus = function (courseId, lessonId, exerciseId, uid) {
        var _this = this;
        this.log('getStudentStatus <<<');
        if (!courseId || courseId === '') {
            return Promise.reject('getStudentStatus# courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('getStudentStatus# lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('getStudentStatus# exerciseId cannot be empty!');
        }
        if (!uid || uid === '') {
            return Promise.reject('getStudentStatus# studentStatusId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(uid);
        this.log('getStudentStatus# path:', path);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var ss = snapshot.val();
            _this.log('getStudentStatus#', ss);
            if (ss) {
                future.resolve(ss);
            }
            else {
                future.reject("getStudentStatus#", "Cannot find StudentStatus for ".concat(path));
            }
        })
            .catch(function (err) {
            _this.log("getStudentStatus#, error", err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.findStudentStatus = function (studentStatusListSnapshot, uid) {
        var studentStatus;
        studentStatusListSnapshot.forEach(function (studentStatusSnapshot) {
            var ss = studentStatusSnapshot.val();
            if (!studentStatus && ss && ss.student && ss.student.uid === uid) {
                studentStatus = ss;
            }
        });
        return studentStatus;
    };
    CourseProviderImpl.prototype.toExerciseStatusList = function (lessonSnapshot, uid) {
        var _this = this;
        var exerciseStatusList = [];
        if (!lessonSnapshot) {
            return exerciseStatusList;
        }
        lessonSnapshot.forEach(function (exerciseStatusSnapshot) {
            var ss = exerciseStatusSnapshot.val();
            if (ss) {
                var studentStatus = _this.findStudentStatus(exerciseStatusSnapshot, uid);
                exerciseStatusList.push({
                    exerciseId: exerciseStatusSnapshot.key,
                    studentStatus: studentStatus
                });
            }
        });
        return exerciseStatusList;
    };
    CourseProviderImpl.prototype.toLessonStatusList = function (courseSnapshot, uid) {
        var _this = this;
        var lessonStatusList = [];
        if (!courseSnapshot) {
            return lessonStatusList;
        }
        courseSnapshot.forEach(function (lessonSnapshot) {
            lessonStatusList.push({
                lessonId: lessonSnapshot.key,
                exerciseStatusList: _this.toExerciseStatusList(lessonSnapshot, uid)
            });
        });
        return lessonStatusList;
    };
    CourseProviderImpl.prototype.getLessonExerciseStatus = function (courseId, lessonId) {
        var _this = this;
        if (!courseId || !lessonId) {
            return Promise.reject('getLessonExerciseStatus# error! courseId and lessonId cannot be blank!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId))
            .then(function (snapshot) {
            future.resolve(_this.toExerciseStatusList(snapshot, currentUser.uid));
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getCourseExerciseStatus = function (courseId) {
        var _this = this;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('getCourseExerciseStatus# error! courseId cannot be blank!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/student-status/").concat(courseId))
            .then(function (snapshot) {
            future.resolve(_this.toLessonStatusList(snapshot, currentUser.uid));
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.toLessonStatusList4Course = function (courseSnapshot, isSingleStudent) {
        var _this = this;
        var lessonStatusList = [];
        if (!courseSnapshot) {
            return lessonStatusList;
        }
        courseSnapshot.forEach(function (lessonSnapshot) {
            lessonStatusList.push({
                lessonId: lessonSnapshot.key,
                exerciseStatusList: isSingleStudent
                    ? _this.toExerciseStatus4Course(lessonSnapshot)
                    : _this.toExerciseStatusList4Course(lessonSnapshot)
            });
        });
        return lessonStatusList;
    };
    CourseProviderImpl.prototype.toExerciseStatusList4Course = function (lessonSnapshot) {
        var exerciseStatusList = [];
        if (!lessonSnapshot) {
            return exerciseStatusList;
        }
        lessonSnapshot.forEach(function (exerciseStatusSnapshot) {
            var studentStatusList = exerciseStatusSnapshot.val();
            if (studentStatusList) {
                exerciseStatusList.push({
                    exerciseId: exerciseStatusSnapshot.key,
                    studentStatusList: studentStatusList
                });
            }
        });
        return exerciseStatusList;
    };
    CourseProviderImpl.prototype.toExerciseStatus4Course = function (lessonSnapshot) {
        var exerciseStatusList = [];
        var currentUser = (0, UserCache_1.loadUser)();
        if (!lessonSnapshot) {
            return exerciseStatusList;
        }
        lessonSnapshot.forEach(function (exerciseStatusSnapshot) {
            var studentStatusList = exerciseStatusSnapshot.val();
            if (studentStatusList && studentStatusList[currentUser.uid]) {
                exerciseStatusList.push({
                    exerciseId: exerciseStatusSnapshot.key,
                    studentStatus: studentStatusList[currentUser.uid]
                });
            }
        });
        return exerciseStatusList;
    };
    CourseProviderImpl.prototype.getStudentStatusByCourse = function (courseId, unit) {
        var _this = this;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('getStudentStatusByCourse# error! courseId cannot be blank!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var curUnit = unit || currentUser.unit;
        (0, FirebaseUtils_1.getNode)("/units/".concat(curUnit, "/student-status/").concat(courseId))
            .then(function (snapshot) {
            future.resolve(_this.toLessonStatusList4Course(snapshot, false));
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getOwnStudentStatusByCourse = function (courseId) {
        var _this = this;
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('getOwnStudentStatusByCourse# error! courseId cannot be blank!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/student-status/").concat(courseId))
            .then(function (snapshot) {
            future.resolve(_this.toLessonStatusList4Course(snapshot, true));
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.listenAllStudentStatus = function (courseId, lessonId, exerciseId, listener) {
        var _this = this;
        if (!courseId || courseId === '') {
            this.log('listenAllStudentStatus#', 'courseId cannot be empty!');
            return;
        }
        if (!lessonId || lessonId === '') {
            this.log('listenAllStudentStatus#', 'lessonId cannot be empty!');
            return;
        }
        if (!exerciseId || exerciseId === '') {
            this.log('listenAllStudentStatus#', 'exerciseId cannot be empty!');
            return;
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/");
        this.log('listenAllStudentStatus#', path);
        this.dataSyncProvider
            .unsubscribe(this.nodeListenAllStudentStatus)
            .then(function () {
            var dataSyncListener = {
                onChanged: function (data) {
                    var studentStatusList = data ? (0, Utils_1.objectToList)(data) : [];
                    listener.onListChanged(studentStatusList);
                }
            };
            _this.dataSyncProvider
                .subscribe(path, path, dataSyncListener)
                .then(function (dataSyncNode) {
                _this.nodeListenAllStudentStatus = dataSyncNode;
            })
                .catch(function (err) { return _this.log(err); });
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.getCompleteCount = function (courseId, lessonId, exerciseId) {
        var _this = this;
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/"))
            .then(function (snapshot) {
            var completeCount = 0;
            snapshot.forEach(function (childSnapshot) {
                var obj = childSnapshot.val();
                if (obj.status === 'finished') {
                    completeCount++;
                }
                return false;
            });
            future.resolve(completeCount);
        })
            .then(function () {
            _this.log("listenStudentStatus, ok");
        })
            .catch(function (err) {
            _this.log("listenStudentStatus error: ", err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.setupVideoConference = function (courseId, meetingNumber, meetingPassword, courseObj) {
        if (courseObj === void 0) { courseObj = {}; }
        return Promise.resolve('do in the future!');
    };
    CourseProviderImpl.prototype.endVideoConference = function (courseId) {
        return Promise.resolve('do in the future!');
    };
    CourseProviderImpl.prototype.getVideoConferenceInfos = function () {
        return Promise.resolve('do in the future!');
    };
    CourseProviderImpl.prototype.listenVideoConference = function (listener) {
        return Promise.resolve('do in the future!');
    };
    CourseProviderImpl.prototype.listenStudentStatus = function (courseId, lessonId, exerciseId, userId, listener) {
        var _this = this;
        if (!courseId || courseId === '') {
            this.log('listenStudentStatus#', 'courseId cannot be empty!');
            return;
        }
        if (!lessonId || lessonId === '') {
            this.log('listenStudentStatus#', 'lessonId cannot be empty!');
            return;
        }
        if (!exerciseId || exerciseId === '') {
            this.log('listenStudentStatus#', 'exerciseId cannot be empty!');
            return;
        }
        if (!userId || userId === '') {
            this.log('listenStudentStatus#', 'userId cannot be empty!');
            return;
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(userId);
        this.log('listenStudentStatus# path:', path);
        if (courseId === '00000') {
            this.dataSyncProvider
                .unsubscribe(this.nodeListenStudentStatusPlaygound)
                .then(function () {
                var dataSyncListener = {
                    onChanged: function (data) {
                        listener.onChanged(data);
                    }
                };
                _this.dataSyncProvider
                    .subscribe(path, path, dataSyncListener)
                    .then(function (dataSyncNode) {
                    _this.nodeListenStudentStatusPlaygound = dataSyncNode;
                })
                    .catch(function (err) { return _this.log(err); });
            })
                .catch(function (err) { return _this.log(err); });
        }
        else {
            this.dataSyncProvider
                .unsubscribe(this.nodeListenStudentStatus)
                .then(function () {
                var dataSyncListener = {
                    onChanged: function (data) {
                        listener.onChanged(data);
                    }
                };
                _this.dataSyncProvider
                    .subscribe(path, path, dataSyncListener)
                    .then(function (dataSyncNode) {
                    _this.nodeListenStudentStatus = dataSyncNode;
                })
                    .catch(function (err) { return _this.log(err); });
            })
                .catch(function (err) { return _this.log(err); });
        }
    };
    CourseProviderImpl.prototype.createStudentStatus = function (courseId, lessonId, exerciseId, user) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        if (!user || !user.uid || user.uid === '') {
            return Promise.reject('user cannot be empty!');
        }
        var studentStatus = {
            id: user.uid,
            courseId: courseId,
            lessonId: lessonId,
            exerciseId: exerciseId,
            student: user,
            status: 'idle',
            codeStatus: 'unknown',
            buildCount: 0,
            tipViewCount: 0,
            answerViewCount: 0,
            duration: 0,
            result: '',
            latestBuildTime: 0,
            readTips: [],
            code: '',
            output: '',
            kernel: {},
            created: app_1.default.database.ServerValue.TIMESTAMP,
            updated: Date.now(),
            observed: false,
            practiceUpdated: Date.now()
        };
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.updateNode)("/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(studentStatus.id), studentStatus)
            .then(function () { return future.resolve(studentStatus); })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    CourseProviderImpl.prototype.cloneStudentStatus = function (ss) {
        return {
            id: ss.id,
            student: ss.student,
            status: 'idle',
            buildCount: 0,
            tipViewCount: 0,
            answerViewCount: 0,
            duration: 0,
            result: '',
            latestBuildTime: 0,
            readTips: [],
            code: '',
            created: app_1.default.database.ServerValue.TIMESTAMP,
            updated: app_1.default.database.ServerValue.TIMESTAMP
        };
    };
    CourseProviderImpl.prototype.startExercise = function (courseId, lessonId, exerciseId, user) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        if (!user || !user.uid || user.uid === '') {
            return Promise.reject('user cannot be empty!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        this.log('startExercise#');
        this.getStudentStatus(courseId, lessonId, exerciseId, user.uid)
            .then(function (ss) {
            _this.log('startExercise# getStudentStatus#', ss);
            var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(user.uid);
            var studentStatus = {
                codeStatus: ss.codeStatus ? ss.codeStatus : ss.status,
                status: ss.status === 'running' ? 'idle' : ss.status,
                courseId: courseId,
                lessonId: lessonId,
                exerciseId: exerciseId,
                updated: Date.now(),
                practiceUpdated: Date.now(),
                focused: true,
                student: {
                    displayName: currentUser.displayName ? currentUser.displayName : '',
                    email: currentUser.email ? currentUser.email : '',
                    photoUrl: currentUser.photoUrl ? currentUser.photoUrl : '',
                    uid: currentUser.uid ? currentUser.uid : '',
                    seatNo: currentUser.moreInfo && currentUser.moreInfo.seatNo
                        ? currentUser.moreInfo.seatNo
                        : ''
                }
            };
            _this.log('startExercise# studentStatus:', studentStatus);
            (0, FirebaseUtils_1.updateNode)(path, studentStatus)
                .then(function () { return future.resolve(ss); })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) {
            _this.log('startExercise# createStudentStatus#', err);
            _this.createStudentStatus(courseId, lessonId, exerciseId, user)
                .then(function (ss) {
                _this.log('startExercise# createStudentStatus#', ss);
                future.resolve(ss);
            })
                .catch(function (err2) { return future.reject(err2); });
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.updateCurrentExercise = function (courseId, lessonId, exerciseId, user) {
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        if (!user || !user.uid || user.uid === '') {
            return Promise.reject('user cannot be empty!');
        }
        var path = "kernels/".concat(user.uid, "/exercise");
        return (0, FirebaseUtils_1.updateNode)(path, {
            courseId: courseId,
            lessonId: lessonId,
            exerciseId: exerciseId
        });
    };
    CourseProviderImpl.prototype.stopCurrentExercise = function () {
        var _this = this;
        var obj = this.getCurrentExercise();
        if (!obj) {
            return Promise.resolve();
        }
        this.log('stopCurrentExercise#', obj);
        if (!obj.courseId || obj.courseId === '') {
            this.log('courseId cannot be empty!');
            return Promise.resolve();
        }
        if (!obj.lessonId || obj.lessonId === '') {
            this.log('lessonId cannot be empty!');
            return Promise.resolve();
        }
        if (!obj.exerciseId || obj.exerciseId === '') {
            this.log('exerciseId cannot be empty!');
            return Promise.resolve();
        }
        if (!obj.uid || obj.uid === '') {
            this.log('user cannot be empty!');
            return Promise.resolve();
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/student-status/").concat(obj.courseId, "/").concat(obj.lessonId, "/").concat(obj.exerciseId, "/").concat(obj.uid);
        if (obj.code) {
            (0, FirebaseUtils_1.updateNode)(path, {
                code: obj.code,
                updated: Date.now(),
                focused: false
            })
                .then(function () { return _this.log('update code ok', path); })
                .catch(function (err) { return _this.log('update code error', err); });
        }
        return this.stopTask(obj.courseId, obj.lessonId, obj.exerciseId, obj.uid);
    };
    CourseProviderImpl.prototype.stopTask = function (courseId, lessonId, exerciseId, userId) {
        var _this = this;
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        if (!userId || userId === '') {
            return Promise.reject('userId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        return this.getStudentStatus(courseId, lessonId, exerciseId, userId)
            .then(function (ss) {
            return (0, FirebaseUtils_1.setNode)("stop/".concat(ss.kernel.name, "/").concat(userId), true)
                .then(function () {
                _this.clearExerciseCache();
                var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(userId);
                return (0, FirebaseUtils_1.updateNode)(path, {
                    status: 'idle'
                });
            })
                .catch(function (err) { return _this.log('stopTask# II Error', err); });
        })
            .catch(function (err) { return _this.log('stopTask# I Error:', err); });
    };
    CourseProviderImpl.prototype.createBuildTask = function (courseId, lessonId, exerciseId, uid, code, kernel, vds, submitType) {
        var _this = this;
        this.log('createBuildTask# <<<<<<< ');
        this.log('createBuildTask# kernel:', kernel);
        this.log('createBuildTask# submitType:', submitType);
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getExercise(courseId, lessonId, exerciseId)
            .then(function (exercise) {
            _this.log('createBuildTask# exercise', exercise);
            if (!exercise && exerciseId !== '00000' && exerciseId !== '11111') {
                future.resolve();
                return;
            }
            _this.log('createBuildTask# task# submitType:', submitType);
            var task = {
                uid: uid,
                unit: currentUser.unit,
                fid: exerciseId,
                fname: exerciseId,
                lessonId: lessonId,
                courseId: courseId,
                exerciseId: exerciseId,
                code: code,
                status: 'edit',
                input: '',
                vds: vds ? vds : [],
                kernel: kernel,
                codeType: exercise && exercise.codeType ? exercise.codeType : 'python',
                timestamp: app_1.default.database.ServerValue.TIMESTAMP,
                submitType: submitType ? submitType : '',
                version: '2.0'
            };
            _this.log('createBuildTask# task:', task);
            (0, FirebaseUtils_1.setNode)("files/".concat(uid, "/build"), task)
                .then(function () {
                _this.log('createBuildTask# files/task');
                if (!(0, Utils_1.isElectron)()) {
                    CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                        .submitCode(task)
                        .then(function () { return _this.log('createBuildTask# tasks/task', task); })
                        .catch(function (err) { return _this.log(err); });
                }
                else {
                    (0, FirebaseUtils_1.setNode)("tasks/".concat(kernel.name, "/").concat(uid), task)
                        .then(function () { return _this.log('createBuildTask# tasks/task', task); })
                        .catch(function (err) { return _this.log(err); });
                }
                future.resolve();
            })
                .catch(function (err) {
                _this.log('createBuildTask# error', err);
                future.resolve();
            });
            future.resolve();
        })
            .catch(function (err) {
            _this.log('createBuildTask# error', err);
            future.resolve();
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.countSubmitCount = function (uid) {
        var _this = this;
        this.log('countSubmitCount#', uid);
        var currentUser = (0, UserCache_1.loadUser)();
        var buildCountChange = FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref("/units/".concat(currentUser.unit, "/history/").concat(uid))
            .transaction(function (userHistory) {
            _this.log('countSubmitCount#', userHistory);
            if (userHistory && !isNaN(userHistory.submitCount)) {
                userHistory.submitCount++;
                userHistory.updated = app_1.default.database.ServerValue.TIMESTAMP;
            }
            return userHistory;
        });
    };
    CourseProviderImpl.prototype.addHistoryOnExistedUser = function (uid, fid) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var newKey = FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref("/units/".concat(currentUser.unit, "/history/").concat(uid, "/histories"))
            .push().key;
        var history = {
            id: newKey,
            fid: fid,
            status: '',
            created: app_1.default.database.ServerValue.TIMESTAMP
        };
        (0, FirebaseUtils_1.setNode)("/units/".concat(currentUser.unit, "/history/").concat(uid, "/histories/").concat(newKey), history)
            .then(function (result) {
            _this.log('addHistoryOnExistedUser# Add history success');
        })
            .catch(function (err) {
            _this.log('error! addHistoryOnExistedUser#');
        });
    };
    CourseProviderImpl.prototype.findSelfKernel = function (uid) {
        var _this = this;
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "kernels/desktop/".concat(uid);
        this.log('findSelfKernel, path:', path);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var kernel = snapshot.val();
            _this.log('findSelfKernel, kernel:', kernel);
            future.resolve(kernel);
        })
            .catch(function (err) { return future.resolve(undefined); });
        return future.promise;
    };
    CourseProviderImpl.prototype.findAvailableKernel = function () {
        var _this = this;
        this.log('findAvailableKernel <<<');
        var future = new Future_1.Future(Future_1.futureFunc);
        var currentUser = (0, UserCache_1.loadUser)();
        if ((0, Utils_1.isElectron)()) {
            this.log('findAvailableKernel# for Desktop App');
            this.findSelfKernel(currentUser.uid)
                .then(function (kernel) {
                return future.resolve(kernel);
            })
                .catch(function (err) {
                _this.log('findAvailableKernel# error:', err);
                future.resolve(undefined);
            });
        }
        else {
            this.findCloudKernel()
                .then(function (k) {
                future.resolve(k);
            })
                .catch(function (err) {
                _this.log('findAvailableKernel# error:', err);
                future.resolve(undefined);
            });
        }
        return future.promise;
    };
    CourseProviderImpl.prototype.getAvailableKernels = function () {
        var _this = this;
        this.log('getAvailableKernels <<<');
        var future = new Future_1.Future(Future_1.futureFunc);
        var currentUser = (0, UserCache_1.loadUser)();
        this.getCloudKernels()
            .then(function (kernels) {
            _this.log('getAvailableKernels# Cloud kernels:', kernels);
            var availableKernels = [];
            if (kernels) {
                availableKernels = availableKernels.concat(kernels);
            }
            _this.findSelfKernel(currentUser.uid)
                .then(function (kernel) {
                _this.log('getAvailableKernels# findSelfKernel:', kernel);
                availableKernels = availableKernels.concat(kernel);
                future.resolve(availableKernels.filter(function (k) { return Date.now() - k.updated < 1000 * 60 * 2; }));
            })
                .catch(function (err) {
                _this.log('getAvailableKernels# error:', err);
                future.resolve(availableKernels.filter(function (kernel) {
                    return !kernel ? false : Date.now() - kernel.updated < 1000 * 60 * 2;
                }));
            });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    CourseProviderImpl.prototype.findCloudKernel = function () {
        var _this = this;
        this.log('findCloudKernel <<<');
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "kernels/cloud/airabbi";
        this.log('findCloudKernel# finding cloud kernel:', path);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var kernel = snapshot.val();
            _this.log('findCloudKernel# found cloud kernel:', kernel);
            future.resolve(kernel);
        })
            .catch(function (err) {
            _this.log("findCloudKernel#, error", err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getCloudKernels = function () {
        var _this = this;
        this.log('findCloudKernels <<<');
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "kernels/cloud";
        this.log('findCloudKernels# finding cloud kernels:', path);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var kernel = snapshot.val();
            future.resolve((0, Utils_1.objectToList)(kernel));
        })
            .catch(function (err) {
            _this.log("findCloudKernel#, error", err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.saveCurrentExercise = function (courseId, lessonId, exerciseId, uid, code) {
        var key = 'current_exercise';
        localStorage.setItem('exercise_type', '');
        if (courseId === '00000' && lessonId === '00000' && exerciseId === '00000') {
            key = 'playground_exercise';
            localStorage.setItem('exercise_type', 'playground');
        }
        localStorage.setItem(key, JSON.stringify({
            courseId: courseId,
            lessonId: lessonId,
            exerciseId: exerciseId,
            uid: uid,
            code: code
        }));
    };
    CourseProviderImpl.prototype.getExerciseLocalStorageKey = function () {
        return localStorage.getItem('exercise_type') === 'playground'
            ? 'playground_exercise'
            : 'current_exercise';
    };
    CourseProviderImpl.prototype.clearExerciseCache = function () {
        var key = this.getExerciseLocalStorageKey();
        localStorage.removeItem(key);
    };
    CourseProviderImpl.prototype.getCurrentExercise = function () {
        var key = this.getExerciseLocalStorageKey();
        var data = localStorage.getItem(key);
        if (!data || data.trim().length === 0) {
            return undefined;
        }
        return JSON.parse(data);
    };
    CourseProviderImpl.prototype.submitCode = function (courseId, lessonId, exerciseId, uid, code, vds, kernel, submitType, version, stepId, codeType) {
        var _this = this;
        if (codeType === void 0) { codeType = ''; }
        this.log('submitCode# kernel:', kernel);
        this.log('submitCode# submitType:', submitType);
        if (!courseId || courseId === '') {
            return Promise.reject('runCode# courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('runCode# lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('runCode# exerciseId cannot be empty!');
        }
        if (!uid || uid === '') {
            return Promise.reject('runCode# uid cannot be empty!');
        }
        if (!code) {
            return Promise.reject('runCode# code cannot be empty!');
        }
        this.saveCurrentExercise(courseId, lessonId, exerciseId, uid, code);
        if (kernel) {
            this.log('submitCode# runCode# kernel:', kernel);
            this.log('submitCode# runCode# submitType:', submitType);
            return this.runCode(courseId, lessonId, exerciseId, uid, code, vds, kernel, submitType);
        }
        return this.findAvailableKernel().then(function (availableKernel) {
            _this.log('submitCode# runCode# availableKernel:', availableKernel);
            _this.log('submitCode# runCode# submitType:', submitType);
            return _this.runCode(courseId, lessonId, exerciseId, uid, code, vds, availableKernel, submitType);
        });
    };
    CourseProviderImpl.prototype.runCode = function (courseId, lessonId, exerciseId, uid, code, vds, kernel, submitType) {
        var _this = this;
        if (!kernel) {
            return Promise.reject('runCode# Invalid kernel!');
        }
        this.log('runCode# kernel:', kernel);
        this.log('runCode# submitType:', submitType);
        var future = new Future_1.Future(Future_1.futureFunc);
        this.updateFile(uid, exerciseId, code)
            .then(function () {
            _this.log('runCode# updateFile, done');
            _this.updateStudentStatusBuildCount(courseId, lessonId, exerciseId, uid, code, kernel);
            _this.createBuildTask(courseId, lessonId, exerciseId, uid, code, kernel, vds, submitType)
                .then(function () {
                _this.log('runCode# createBuildTask, done');
                future.resolve();
            })
                .catch(function (err) {
                _this.log('runCode# createBuildTask, error');
                future.reject(err);
            });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    CourseProviderImpl.prototype.updateStudentStatusBuildCount = function (courseId, lessonId, exerciseId, uid, code, kernel) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        this.getStudentStatus(courseId, lessonId, exerciseId, uid)
            .then(function (ss) {
            var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(uid);
            _this.log('updateStudentStatusBuildCount# path:', path);
            _this.log('updateStudentStatusBuildCount# ss:', ss);
            (0, FirebaseUtils_1.updateNode)(path, {
                buildCount: ss.buildCount + 1,
                code: code,
                output: '',
                kernel: kernel
            })
                .then(function () { return _this.log('updateStudentStatusBuildCount# successfully'); })
                .catch(function (err) { return _this.log('updateStudentStatusBuildCount# error:', err); });
        })
            .catch(function (err) { return _this.log('updateStudentStatusBuildCount# getStudentStatus# error:', err); });
    };
    CourseProviderImpl.prototype.updateStudentStatusCode = function (courseId, lessonId, exerciseId, uid, code) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/code/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(uid);
        this.log('updateStudentStatusCode# path:', path);
        (0, FirebaseUtils_1.updateNode)(path, {
            code: code,
            focused: true,
            codeUpdated: app_1.default.database.ServerValue.TIMESTAMP
        })
            .then(function () { return _this.log('updateStudentStatusCode# successfully'); })
            .catch(function (err) { return _this.log('updateStudentStatusCode# error:', err); });
    };
    CourseProviderImpl.prototype.updateStudentCodeStatus = function (courseId, lessonId, exerciseId, code, codeStatus, status, stepId) {
        var _this = this;
        if (stepId === void 0) { stepId = ''; }
        var currentUser = (0, UserCache_1.loadUser)();
        var uid = currentUser.uid;
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getStudentStatus(courseId, lessonId, exerciseId, uid)
            .then(function (ss) {
            if (codeStatus !== 'finished' && ss && ss.codeStatus === 'finished') {
                codeStatus = ss.codeStatus;
            }
            var stepResults = ss && ss.stepResults ? ss.stepResults : {};
            if (stepId) {
                var stepResult = stepResults[stepId] ? stepResults[stepId] : {};
                stepResult.code = code;
                stepResult.status = status;
                stepResult.codeStatus =
                    stepResult.codeStatus === 'finished' ? stepResult.codeStatus : codeStatus;
                stepResult.buildCount = stepResult.buildCount ? parseInt(stepResult.buildCount) + 1 : 1;
                stepResults[stepId] = stepResult;
            }
            var finishedTime = ss.finishedTime;
            if (ss &&
                ss.codeStatus !== 'finished' &&
                status === 'finished' &&
                typeof ss.finishedTime !== 'number') {
                finishedTime = Date.now();
            }
            var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(uid);
            _this.log('updateStudentCodeStatus# path:', path);
            _this.log('updateStudentCodeStatus# ss:', ss);
            (0, FirebaseUtils_1.updateNode)(path, {
                codeStatus: codeStatus,
                status: status,
                code: code,
                finishedTime: finishedTime ? finishedTime : '',
                stepResults: stepResults ? stepResults : {}
            })
                .then(function () {
                _this.log('updateStudentCodeStatus# successfully');
                future.resolve();
            })
                .catch(function (err) {
                _this.log('updateStudentCodeStatus# error:', err);
                future.reject(err);
            });
        })
            .catch(function (err) {
            _this.log('updateStudentCodeStatus# getStudentStatus# error:', err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.moveCurrentCodeToStudentStatus = function () {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var currentExercise = this.getCurrentExercise();
        if (!currentExercise) {
            return Promise.resolve();
        }
        var courseId = currentExercise.courseId, lessonId = currentExercise.lessonId, exerciseId = currentExercise.exerciseId, code = currentExercise.code;
        if (!courseId || !lessonId || !exerciseId || !code) {
            return Promise.resolve();
        }
        if (courseId.trim() === '' ||
            lessonId.trim() === '' ||
            exerciseId.trim() === '' ||
            code.trim() === '') {
            return Promise.resolve();
        }
        return this.getStudentStatus(courseId, lessonId, exerciseId, currentUser.uid).then(function (ss) {
            var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(currentUser.uid);
            _this.log('moveCurrentCodeToStudentStatus# path:', path);
            _this.log('moveCurrentCodeToStudentStatus# ss:', ss);
            _this.clearExerciseCache();
            return (0, FirebaseUtils_1.updateNode)(path, {
                code: code
            });
        });
    };
    CourseProviderImpl.prototype.sendInput = function (userId, input) {
        return (0, FirebaseUtils_1.setNode)("files/".concat(userId, "/build/input"), input);
    };
    CourseProviderImpl.prototype.readTip = function (courseId, lessonId, exerciseId, user, lessonIndex, exerciseIndex, tipIndex, tip) {
        var _this = this;
        if (!tip) {
            throw new Error('readTip# tip is undefined!');
            return;
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var sspath = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(user.uid);
        this.log('readTip# sspath:' + sspath);
        var buildCountChange = FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref(sspath)
            .transaction(function (ss) {
            _this.log('readTip# update student status:', ss);
            if (ss) {
                if (!ss.readTips) {
                    ss.readTips = [];
                }
                if (!ss.readTips.find(function (t) { return t.title === tip.title; })) {
                    ss.readTips.push(tip);
                }
            }
            return ss;
        });
        var epath = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/exercises/").concat(exerciseIndex, "/tips/").concat(tipIndex);
        var updateTipCount = FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref(epath)
            .transaction(function (t) {
            _this.log('readTip# update tip count:', t);
            if (t) {
                if (isNaN(t.viewCount)) {
                    t.viewCount = 0;
                }
                if (!t.viewers) {
                    t.viewers = [];
                }
                if (!t.viewers.find(function (v) { return v.uid === user.uid; })) {
                    t.viewers.push(user);
                }
                t.viewCount++;
            }
            return t;
        });
    };
    CourseProviderImpl.prototype.readAnswer = function (courseId, lessonId, exerciseId, user, lessonIndex, exerciseIndex, ansIndex, answer) {
        var _this = this;
        if (!answer) {
            return;
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var sspath = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(user.uid);
        this.log('readAnswer# sspath:' + sspath);
        var buildCountChange = FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref(sspath)
            .transaction(function (ss) {
            _this.log('readAnswer# update student status:', ss);
            if (ss) {
                if (!ss.readAnswers) {
                    ss.readAnswers = [];
                }
                if (!ss.readAnswers.find(function (a) { return a.title === answer.title; })) {
                    ss.readAnswers.push(answer);
                }
            }
            return ss;
        });
        var epath = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/exercises/").concat(exerciseIndex, "/answers/").concat(ansIndex);
        this.log('readAnswer# epath:' + epath);
        var updateTipCount = FirebaseApp_1.FirebaseApp.GET()
            .firebase.database()
            .ref(epath)
            .transaction(function (t) {
            _this.log('readAnswer# update answer count:', t);
            if (t) {
                if (isNaN(t.viewCount)) {
                    t.viewCount = 0;
                }
                if (!t.viewers) {
                    t.viewers = [];
                }
                if (!t.viewers.find(function (v) { return v.uid === user.uid; })) {
                    t.viewers.push(user);
                }
                t.viewCount++;
            }
            return t;
        });
    };
    CourseProviderImpl.prototype.setShowExerciseAnswer = function (courseId, lessonIndex, exerciseIndex, isShowAnswer, isOffline) {
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/").concat(isOffline ? 'offlineExercises' : 'exercises', "/").concat(exerciseIndex, "/isShowAnswer");
        var pathDB = "lessons.".concat(lessonIndex, "/").concat(isOffline ? 'offlineExercises' : 'exercises', ".").concat(exerciseIndex, "/isShowAnswer");
        return Promise.all([
            this.setCourseData(courseId, pathDB, isShowAnswer),
            (0, FirebaseUtils_1.setNode)(path, isShowAnswer)
        ]).then(function (results) {
            return Promise.resolve();
        });
    };
    CourseProviderImpl.prototype.getAllExercises = function (lesson) {
        var exercises = [];
        if (lesson.exercises) {
            lesson.exercises.forEach(function (e) {
                exercises.push(e);
            });
        }
        if (lesson.offlineExercises) {
            lesson.offlineExercises.forEach(function (e) {
                exercises.push(e);
            });
        }
        return exercises;
    };
    CourseProviderImpl.prototype.getMyExercisesByPagination = function (courseId, lessonIndex) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex);
        this.log('getMyExercisesByPagination, path', path);
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var lesson = snapshot.val();
            _this.log('getMyExercisesByPagination, lesson:', lesson);
            var exercises = [];
            if (lesson.exercises) {
                lesson.exercises.forEach(function (e) {
                    exercises.push(e);
                });
            }
            if (lesson.offlineExercises) {
                lesson.offlineExercises.forEach(function (e) {
                    exercises.push(e);
                });
            }
            future.resolve(exercises);
        })
            .catch(function (err) {
            future.resolve([]);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getOpenedExerciseList = function (courseId, lessonIndex) {
        var _this = this;
        this.log('getLessonOpenedExerciseList#, courseId:', courseId);
        this.log('getLessonOpenedExerciseList#, lessonIndex:', lessonIndex);
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId.trim().length === 0) {
            return Promise.reject('getOpenedExerciseList# invalid parameters');
        }
        var path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex);
        this.log('getLessonOpenedExerciseList#, path of lesson:', path);
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var lesson = snapshot.val();
            if (!lesson) {
                future.reject('getOpenedExerciseList# cannot find lesson for ' + path);
                return;
            }
            var exercises = _this.getAllExercises(lesson);
            if (!exercises) {
                future.reject('getOpenedExerciseList# no exercises inf lesson');
                return;
            }
            var openedExercises = exercises.filter(function (e) { return e && e.isShowContent; });
            if (!lesson.openList && openedExercises && openedExercises.length > 0) {
                _this.log('getOpenedExerciseList# openList is empty but opened exercises is not empty!');
                var openList_1 = [];
                openedExercises.forEach(function (e) { return openList_1.push(e.id); });
                path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/openList");
                (0, FirebaseUtils_1.setNode)(path, openList_1)
                    .then(function () {
                    _this.log('getOpenedExerciseList# update openList successfully!');
                    future.resolve(openList_1);
                })
                    .catch(function (err) {
                    _this.log('getOpenedExerciseList# err:', err);
                    future.reject(err);
                });
            }
            if (lesson.openList &&
                openedExercises &&
                lesson.openList.length !== openedExercises.length) {
                _this.log("getOpenedExerciseList# openList length doesn't equal to openedExercises length!");
                var openList_2 = [];
                openedExercises.forEach(function (e) { return openList_2.push(e.id); });
                path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/openList");
                (0, FirebaseUtils_1.setNode)(path, openList_2)
                    .then(function () {
                    _this.log('getOpenedExerciseList# update openList successfully!');
                    future.resolve(openList_2);
                })
                    .catch(function (err) {
                    _this.log('getOpenedExerciseList# err:', err);
                    future.reject(err);
                });
            }
            future.resolve(lesson.openList ? lesson.openList : []);
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    CourseProviderImpl.prototype.getExercise = function (courseId, lessonId, exerciseId) {
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getCourse(courseId)
            .then(function (course) {
            if (!course.lessons) {
                future.resolve(undefined);
                return;
            }
            var lesson = course.lessons.find(function (l) { return l.id === lessonId; });
            if (!lesson) {
                lesson = course.tests.find(function (t) { return t.id === lessonId; });
            }
            if (!lesson || (!lesson.exercises && !lesson.offlineExercises)) {
                future.resolve(undefined);
                return;
            }
            var exercise;
            if (lesson.exercises) {
                exercise = lesson.exercises.find(function (e) { return e.id === exerciseId; });
            }
            if (!exercise && lesson.offlineExercises) {
                exercise = lesson.offlineExercises.find(function (e) { return e.id === exerciseId; });
            }
            future.resolve(exercise);
        })
            .catch(function (err) { return future.resolve(undefined); });
        return future.promise;
    };
    CourseProviderImpl.prototype.setShowExerciseContent = function (courseId, lessonIndex, exerciseIndex, exerciseId, isShowContent, isOffline) {
        var _this = this;
        this.log('setShowExerciseContent#, courseId:', courseId);
        this.log('setShowExerciseContent#, lessonIndex:', lessonIndex);
        this.log('setShowExerciseContent#, exerciseId:', exerciseId);
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getOpenedExerciseList(courseId, lessonIndex)
            .then(function (openList) {
            _this.log("setShowExerciseContent#, openList:", openList);
            openList.forEach(function (eid) {
                _this.log("setShowExerciseContent#, eid".concat(eid, ":"), eid === exerciseId);
            });
            var found = openList.find(function (eid) { return eid === exerciseId; });
            _this.log("setShowExerciseContent#, found:", found);
            if (!found && !isShowContent) {
                _this.log("setShowExerciseContent#, exercise is not found to close!");
                future.resolve();
                return;
            }
            if (found && isShowContent) {
                _this.log("setShowExerciseContent#, exercise is already opened! ".concat(exerciseId));
                future.resolve();
                return;
            }
            if (!found && isShowContent) {
                _this.log("setShowExerciseContent#, push into open list!");
                openList.push(exerciseId);
            }
            if (found && !isShowContent) {
                _this.log("setShowExerciseContent#, remove from open list!");
                var index = openList.indexOf(exerciseId);
                if (index > -1) {
                    _this.log("setShowExerciseContent#, remove from open list! index:", index);
                    openList.splice(index, 1);
                }
            }
            var path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/openList");
            _this.log('setShowExerciseContent#, update openList:', openList);
            (0, FirebaseUtils_1.setNode)(path, openList)
                .then(function () {
                _this.log('setShowExerciseContent, update openList successfully');
                var lessonExercisesPath = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/").concat(isOffline ? 'offlineExercises' : 'exercises', "/").concat(exerciseIndex);
                (0, FirebaseUtils_1.updateNode)(lessonExercisesPath, { isShowContent: isShowContent })
                    .then(function () {
                    _this.log('setShowExerciseContent, update isShowContent successfully', isShowContent);
                    future.resolve();
                })
                    .catch(function (err) { return future.reject(err); });
            })
                .catch(function (err) {
                future.reject(err);
            });
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.setShowExerciseTip = function (courseId, lessonIndex, exerciseIndex, isShowTip, isOffline) {
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(lessonIndex, "/").concat(isOffline ? 'offlineExercises' : 'exercises', "/").concat(exerciseIndex, "/isShowTip");
        return (0, FirebaseUtils_1.setNode)(path, isShowTip);
    };
    CourseProviderImpl.prototype.incrementDuration = function (courseId, lessonId, exerciseId, userId, offset) {
    };
    CourseProviderImpl.prototype.saveCode = function (courseId, lessonId, exerciseId, userId, code) {
        if (!courseId || courseId === '') {
            return;
        }
        if (!lessonId || lessonId === '') {
            return;
        }
        if (!exerciseId || exerciseId === '') {
            return;
        }
        if (!userId || userId === '') {
            return;
        }
        this.log('saveCode#', code);
        if (code === undefined) {
            this.log('saveCode# return code is empty');
            return;
        }
        this.saveCurrentExercise(courseId, lessonId, exerciseId, userId, code);
        this.updateStudentStatusCode(courseId, lessonId, exerciseId, userId, code);
    };
    CourseProviderImpl.prototype.listenLesson = function (courseId, lessonId, listener) {
        var _this = this;
        this.log("listenLesson, ......... off", this.nodeListenLesson);
        if (!courseId && courseId.trim() === '') {
            this.log('courseId cannot be empty!');
            return;
        }
        if (!lessonId && lessonId.trim() === '') {
            this.log('lessonId cannot be empty!');
            return;
        }
        if (!listener) {
            this.log('listener cannot be empty!');
            return;
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons");
        this.log('listenLesson#', path);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var lessons = snapshot.val();
            _this.log('listenLesson# on# path:', path);
            _this.log('listenLesson# on# lessons:', lessons);
            if (lessons) {
                var idx = lessons.findIndex(function (t) { return t.id === lessonId; });
                if (idx !== -1) {
                    path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/lessons/").concat(idx, "/");
                    _this.dataSyncProvider
                        .unsubscribe(_this.nodeListenTest)
                        .then(function () {
                        var dataSyncListener = {
                            onChanged: function (data) {
                                listener.onChanged(data);
                            }
                        };
                        _this.dataSyncProvider
                            .subscribe(path, path, dataSyncListener)
                            .then(function (dataSyncNode) {
                            _this.nodeListenTest = dataSyncNode;
                        })
                            .catch(function (err) { return _this.log(err); });
                    })
                        .catch(function (err) { return _this.log(err); });
                }
                else {
                    _this.log('listenLesson# cannot find lesson ' + lessonId);
                }
            }
            else {
                _this.log('listenLesson# No lessons in ' + courseId);
            }
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.listenCode = function (courseId, lessonId, exerciseId, userId, listener) {
        var _this = this;
        this.log('listenCode#');
        var currentUser = (0, UserCache_1.loadUser)();
        this.log("listenCode# nodeListenCode:", this.nodeListenCode);
        if (!courseId || courseId === '') {
            this.log('listenCode# courseId cannot be empty!');
            return;
        }
        if (!lessonId || lessonId === '') {
            this.log('listenCode# lessonId cannot be empty!');
            return;
        }
        if (!exerciseId || exerciseId === '') {
            this.log('listenCode# exerciseId cannot be empty!');
            return;
        }
        if (!userId || userId === '') {
            this.log('listenCode# userId cannot be empty!');
            return;
        }
        if (!listener) {
            this.log('listener cannot be empty!');
            return;
        }
        var path = "/units/".concat(currentUser.unit, "/code/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(userId);
        this.log('listenCode# path:', path);
        this.dataSyncProvider
            .unsubscribe(this.nodeListenCode)
            .then(function () {
            var dataSyncListener = {
                onChanged: function (data) {
                    listener.onChanged(data);
                }
            };
            _this.dataSyncProvider
                .subscribe(path, path, dataSyncListener)
                .then(function (dataSyncNode) {
                _this.nodeListenCode = dataSyncNode;
            })
                .catch(function (err) { return _this.log(err); });
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.observeThisStudent = function (courseId, lessonId, exerciseId, userId, observed) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty');
        }
        if (!userId || userId === '') {
            return Promise.reject('userId cannot be empty');
        }
        var user = (0, UserCache_1.loadUser)();
        if (!user || !user.uid || user.uid.trim() === '' || !user.unit || user.unit.trim() === '') {
            return Promise.reject('userId cannot be empty');
        }
        var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(userId);
        this.log('observeThisStudent', path);
        return (0, FirebaseUtils_1.updateNode)(path, {
            observed: observed
        });
    };
    CourseProviderImpl.prototype.updateDuration = function (courseId, lessonId, exerciseId, userId) {
        var _this = this;
        if (!courseId || courseId === '') {
            this.log('updateDuration# courseId cannot be empty!');
            return Promise.reject('updateDuration# courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            this.log('updateDuration# lessonId cannot be empty!');
            return Promise.reject('updateDuration# lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            this.log('updateDuration# exerciseId cannot be empty!');
            return Promise.reject('updateDuration# exerciseId cannot be empty!');
        }
        if (!userId || userId === '') {
            this.log('updateDuration# userId cannot be empty!');
            return Promise.reject('updateDuration# userId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getStudentStatus(courseId, lessonId, exerciseId, userId)
            .then(function (ss) {
            var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(userId);
            _this.log('updateDuration# path:', path);
            _this.log('updateDuration# ss.practiceUpdated:', ss.practiceUpdated);
            _this.log('updateDuration# ss.duration:', ss.duration);
            var timeOffset = 0;
            try {
                timeOffset = ss.practiceUpdated !== undefined ? Date.now() - ss.practiceUpdated : 0;
            }
            catch (e) {
                var logger = console;
                logger.error(e);
            }
            _this.log('updateDuration# ss: add timeOffset:', timeOffset);
            (0, FirebaseUtils_1.updateNode)(path, {
                updated: Date.now(),
                practiceUpdated: Date.now(),
                duration: ss.duration + timeOffset
            })
                .then(function () {
                _this.log('updateDuration# successfully');
                future.resolve();
            })
                .catch(function (err) {
                _this.log('updateDuration# error:', err);
                future.resolve();
            });
        })
            .catch(function (err) {
            _this.log('updateDuration# error:', err);
            future.resolve();
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.createComment = function (courseId, lessonId, teacherId, studentId, content) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!studentId || studentId === '') {
            return Promise.reject('studentId cannot be empty!');
        }
        if (!teacherId || teacherId === '') {
            return Promise.reject('teacherId cannot be empty!');
        }
        if (!content || content === '') {
            return Promise.reject('content cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/comments/").concat(courseId, "/").concat(lessonId, "/").concat(studentId);
        return (0, FirebaseUtils_1.setNode)(path, {
            lessonId: lessonId,
            studentId: studentId,
            teacher: teacherId,
            content: content,
            updated: app_1.default.database.ServerValue.TIMESTAMP
        });
    };
    CourseProviderImpl.prototype.updateComment = function (courseId, lessonId, teacherId, studentId, content) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!studentId || studentId === '') {
            return Promise.reject('studentId cannot be empty!');
        }
        if (!teacherId || teacherId === '') {
            return Promise.reject('teacherId cannot be empty!');
        }
        if (!content || content === '') {
            return Promise.reject('content cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/comments/").concat(courseId, "/").concat(lessonId, "/").concat(studentId);
        return (0, FirebaseUtils_1.updateNode)(path, {
            lessonId: lessonId,
            studentId: studentId,
            teacher: teacherId,
            content: content,
            updated: app_1.default.database.ServerValue.TIMESTAMP
        });
    };
    CourseProviderImpl.prototype.removeComment = function (courseId, lessonId, studentId) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!studentId || studentId === '') {
            return Promise.reject('studentId cannot be empty!');
        }
        return (0, FirebaseUtils_1.removeNode)("/units/".concat(currentUser.unit, "/comments/").concat(courseId, "/").concat(lessonId, "/").concat(studentId));
    };
    CourseProviderImpl.prototype.getComment = function (courseId, lessonId, studentId) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!studentId || studentId === '') {
            return Promise.reject('studentId cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/comments/").concat(courseId, "/").concat(lessonId, "/").concat(studentId);
        return (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) { return Promise.resolve(snapshot.val()); })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.getComments = function (courseId, lessonId) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/comments/").concat(courseId))
                .then(function (snapshot) {
                var lessons = (0, FirebaseUtils_1.snapshot2List)(snapshot);
                var comments = [];
                lessons.forEach(function (lesson) {
                    Object.keys(lesson).map(function (key) { return comments.push(lesson[key]); });
                });
                return Promise.resolve(comments);
            })
                .catch(function (err) { return Promise.reject(err); });
        }
        return (0, FirebaseUtils_1.getNode)("/units/".concat(currentUser.unit, "/comments/").concat(courseId, "/").concat(lessonId))
            .then(function (snapshot) {
            var comments = (0, FirebaseUtils_1.snapshot2List)(snapshot);
            return Promise.resolve(comments);
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.openResourceFolder = function () {
        var _this = this;
        this.findAvailableKernel()
            .then(function (kernel) {
            var user = (0, UserCache_1.loadUser)();
            _this.log('openResourceFolder# kernel:', kernel);
            if (kernel && user && kernel.name === user.uid) {
                var path = "kernels/desktop/".concat(kernel.name, "/isOpenResFolder");
                (0, FirebaseUtils_1.updateNode)(path, {
                    isToOpenResourceFolder: true
                })
                    .then(function () { return _this.log('openResourceFolder# ok'); })
                    .catch(function (err) { return _this.log(err); });
            }
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.getSharedMaterials = function (codeType, sharedType, uid) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/materials");
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/materials";
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        this.log('getSharedMaterials# path:', path);
        if (codeType === 'all') {
            return (0, FirebaseUtils_1.getNode)(path)
                .then(function (snapshot) { return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot)); })
                .catch(function (err) { return Promise.reject(err); });
        }
        return (0, FirebaseUtils_1.queryNode)(path, 'codeType', codeType)
            .then(function (snapshot) {
            _this.log('getSharedMaterials# queryNode:', snapshot.val());
            return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot));
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.shareMaterial = function (materialObj, sharedType) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!materialObj || !materialObj.id || !materialObj.owner || !materialObj.url) {
            return Promise.reject('materialObj or attrs cannot be empty!');
        }
        if (!sharedType) {
            return Promise.reject('sharedType cannot be empty!');
        }
        materialObj.sharedType = sharedType;
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/materials/").concat(materialObj.id);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/materials/".concat(materialObj.id);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        return (0, FirebaseUtils_1.setNode)(path, materialObj);
    };
    CourseProviderImpl.prototype.cloneSharedMaterial = function (sharedType, materialId) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!materialId) {
            return Promise.reject('materialId cannot be blank!');
        }
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/materials/").concat(materialId);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/materials/".concat(materialId);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var materialObj = snapshot.val();
            if (!materialObj) {
                return future.reject("materialObj not found! path: ".concat(path));
            }
            materialObj.id = (0, uuid_1.v4)();
            materialObj.title = "".concat(materialObj.title, " (copy)");
            materialObj.owner = currentUser.uid;
            _this.log('cloneSharedMaterial# clone materialObj:', materialObj);
            var tarPath = "/units/".concat(currentUser.unit, "/materials/").concat(currentUser.uid, "/").concat(materialObj.id);
            return (0, FirebaseUtils_1.setNode)(tarPath, materialObj)
                .then(function () {
                _this.log('cloneSharedMaterial# clone materialObj successfully, path:', tarPath);
                _this.log('cloneSharedMaterial# clone materialObj successfully', materialObj);
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.createMaterial = function (codeType, title, url) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!codeType || codeType.trim() === '') {
            return Promise.reject('codeType cannot be empty!');
        }
        if (!title || title.trim() === '') {
            return Promise.reject('codeType cannot be empty!');
        }
        if (!url || url.trim() === '') {
            return Promise.reject('codeType cannot be empty!');
        }
        var material = {
            id: (0, uuid_1.v4)(),
            title: title,
            codeType: codeType,
            owner: currentUser.uid,
            url: url,
            updated: app_1.default.database.ServerValue.TIMESTAMP
        };
        if (!material.id || material.id.trim() === '') {
            return Promise.reject('material id cannot be empty');
        }
        var path = "/units/".concat(currentUser.unit, "/materials/").concat(currentUser.uid, "/").concat(material.id);
        return (0, FirebaseUtils_1.setNode)(path, material);
    };
    CourseProviderImpl.prototype.updateMaterial = function (material, shareType) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!material) {
            return Promise.reject('material cannot be empty!');
        }
        if (!material.id || material.id.trim() === '') {
            return Promise.reject('id cannot be empty!');
        }
        var path;
        if (shareType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/materials/").concat(material.id);
        }
        else if (shareType === 'public') {
            path = "/units/sharedResources/materials/".concat(material.id);
        }
        else {
            path = "/units/".concat(currentUser.unit, "/materials/").concat(currentUser.uid, "/").concat(material.id);
        }
        return (0, FirebaseUtils_1.updateNode)(path, material);
    };
    CourseProviderImpl.prototype.deleteMaterial = function (id) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id.trim() === '') {
            return Promise.reject('material id cannot be empty');
        }
        var path = "/units/".concat(currentUser.unit, "/materials/").concat(currentUser.uid, "/").concat(id);
        return (0, FirebaseUtils_1.removeNode)(path);
    };
    CourseProviderImpl.prototype.deleteShareMaterial = function (id, shareType) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id.trim() === '') {
            return Promise.reject('material id cannot be empty');
        }
        var path;
        if (shareType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/materials/").concat(id);
        }
        else if (shareType === 'public') {
            path = "/units/sharedResources/materials/".concat(id);
        }
        else {
            return Promise.reject('this share type not support!');
        }
        return (0, FirebaseUtils_1.getNode)(path).then(function (snapshot) {
            var material = snapshot.val();
            if (!material) {
                return Promise.reject('shared material not exist!');
            }
            if (currentUser.uid === 'kaydemo-airabbi-com') {
                return (0, FirebaseUtils_1.removeNode)(path);
            }
            if (!material.owner || material.owner !== currentUser.uid) {
                return Promise.reject('owner is wrong!');
            }
            return (0, FirebaseUtils_1.removeNode)(path);
        });
    };
    CourseProviderImpl.prototype.getMaterialUploadUrl = function () {
        var currentUser = (0, UserCache_1.loadUser)();
        return "".concat(Settings_1.Settings.SERVER_CONFIG.connections.api_file_upload, "?uid=").concat(currentUser.uid);
    };
    CourseProviderImpl.prototype.getMaterials = function (codeType, uid) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/materials/").concat(uid, "/");
        if (!uid) {
            path = "/units/".concat(currentUser.unit, "/materials/").concat(currentUser.uid, "/");
        }
        this.log('getMaterials# path:', path);
        if (codeType === 'all') {
            return (0, FirebaseUtils_1.getNode)(path)
                .then(function (snapshot) { return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot)); })
                .catch(function (err) { return Promise.reject(err); });
        }
        return (0, FirebaseUtils_1.queryNode)(path, 'codeType', codeType)
            .then(function (snapshot) {
            _this.log('getMaterials# queryNode:', snapshot.val());
            return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot));
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.getMyMaterialsByPagination = function (codeType, skip, limit, sort, searchString) {
        return Promise.resolve({
            result: [],
            totalCount: 0
        });
    };
    CourseProviderImpl.prototype.setExerciseArchived = function (courseId, lessonId, exerciseId, archived) {
        var _this = this;
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        this.log('setExerciseArchived#');
        this.getStudentStatus(courseId, lessonId, exerciseId, currentUser.uid)
            .then(function (ss) {
            _this.log('setExerciseArchived# getStudentStatus#', ss);
            var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(currentUser.uid);
            (0, FirebaseUtils_1.updateNode)(path, {
                updated: Date.now(),
                archived: archived
            })
                .then(function () { return future.resolve(); })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) {
            _this.log('setExerciseArchived# createStudentStatus#', err);
            var studentInfo = {
                uid: currentUser.uid,
                email: currentUser.email,
                displayName: currentUser.displayName,
                photoUri: currentUser.photoUrl,
                seatNo: currentUser.moreInfo && currentUser.moreInfo.seatNo ? currentUser.moreInfo.seatNo : ''
            };
            _this.createStudentStatus(courseId, lessonId, exerciseId, studentInfo)
                .then(function (ss) {
                _this.log('setExerciseArchived# createStudentStatus# ok# ', ss);
                var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(currentUser.uid);
                return (0, FirebaseUtils_1.updateNode)(path, {
                    updated: Date.now(),
                    archived: archived
                })
                    .then(function () { return future.resolve(); })
                    .catch(function (err2) { return future.reject(err2); });
            })
                .catch(function (err3) { return future.reject(err3); });
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.setExerciseLiked = function (courseId, lessonId, exerciseId, liked) {
        var _this = this;
        if (!courseId || courseId === '') {
            return Promise.reject('courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('exerciseId cannot be empty!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        this.log('setExerciseLiked#');
        this.getStudentStatus(courseId, lessonId, exerciseId, currentUser.uid)
            .then(function (ss) {
            _this.log('setExerciseLiked# getStudentStatus#', ss);
            var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(currentUser.uid);
            (0, FirebaseUtils_1.updateNode)(path, {
                updated: Date.now(),
                liked: liked
            })
                .then(function () { return future.resolve(); })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) {
            _this.log('setExerciseLiked# createStudentStatus#', err);
            var studentInfo = {
                uid: currentUser.uid,
                email: currentUser.email,
                displayName: currentUser.displayName,
                photoUri: currentUser.photoUrl,
                seatNo: currentUser.moreInfo && currentUser.moreInfo.seatNo ? currentUser.moreInfo.seatNo : ''
            };
            _this.createStudentStatus(courseId, lessonId, exerciseId, studentInfo)
                .then(function (ss) {
                _this.log('setExerciseLiked# createStudentStatus# ok# ', ss);
                var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(currentUser.uid);
                return (0, FirebaseUtils_1.updateNode)(path, {
                    updated: Date.now(),
                    liked: liked
                })
                    .then(function () { return future.resolve(); })
                    .catch(function (err2) { return future.reject(err2); });
            })
                .catch(function (err3) { return future.reject(err3); });
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getStudentCoursesByUid = function (uid, user) {
        if (!uid) {
            return Promise.reject('uid not found!');
        }
        var filter = {
            unit: user.unit,
            'students.uid': uid
        };
        var projection = this.getCourseFilterProjection();
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('courses', filter, {}, projection, '')
            .then(function (response) {
            return response.result ? response.result : undefined;
        });
    };
    CourseProviderImpl.prototype.removeUser = function (uid) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        return this.getStudentCoursesByUid(uid, currentUser).then(function (courses) {
            _this.log('removeUser#myCourses# courses[fb]:', courses);
            courses = courses ? courses.reverse() : [];
            courses.forEach(function (course) {
                if (course.students) {
                    var idx = course.students.findIndex(function (s) { return s.uid === uid; });
                    if (idx !== -1) {
                        course.students.splice(idx, 1);
                        _this.log('removeUser#myCourses# students:', course.students);
                        var promise1 = (0, FirebaseUtils_1.setNode)("/units/".concat(currentUser.unit, "/courses/").concat(course.id, "/students"), course.students);
                        var promise2 = CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).updateData('courses', { id: course.id, unit: currentUser.unit }, { students: course.students });
                        _this.clearCourseCache();
                        return Promise.all([promise1, promise2]);
                    }
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        });
    };
    CourseProviderImpl.prototype.updateUser = function (user) {
        var _this = this;
        return this.getMyUnitCoursesWithoutHybird().then(function (courses) {
            _this.log('updateUser#myCourses# courses[fb]:', courses);
            courses.forEach(function (course) {
                if (course.students) {
                    var idx = course.students.findIndex(function (s) { return s.uid === user.uid; });
                    if (idx !== -1) {
                        course.students[idx] = user;
                        return _this.updateCourse(course);
                    }
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        });
    };
    CourseProviderImpl.prototype.getSharedTests = function (codeType, sharedType, uid) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/tests");
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/tests";
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        this.log('getSharedTests# path:', path);
        if (codeType === 'all') {
            return (0, FirebaseUtils_1.getNode)(path)
                .then(function (snapshot) { return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot)); })
                .catch(function (err) { return Promise.reject(err); });
        }
        return (0, FirebaseUtils_1.queryNode)(path, 'codeType', codeType)
            .then(function (snapshot) {
            _this.log('getSharedTests# queryNode:', snapshot.val());
            return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot));
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.shareTest = function (testObj, sharedType) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!testObj || !testObj.id || !testObj.owner) {
            return Promise.reject('shareTest#, incorrect test!');
        }
        testObj.sharedType = sharedType;
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/tests/").concat(testObj.id);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/tests/".concat(testObj.id);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        return (0, FirebaseUtils_1.setNode)(path, testObj);
    };
    CourseProviderImpl.prototype.cloneSharedTest = function (sharedType, testId) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!testId) {
            return Promise.reject('testId cannot be blank!');
        }
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/tests/").concat(testId);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/tests/".concat(testId);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var testObj = snapshot.val();
            if (!testObj) {
                return future.reject("testObj not found! path: ".concat(path));
            }
            testObj.id = (0, uuid_1.v4)();
            testObj.title = "".concat(testObj.title, " (copy)");
            testObj.owner = currentUser.uid;
            _this.log('cloneSharedTest# clone testObj:', testObj);
            var tarPath = "/units/".concat(currentUser.unit, "/tests/").concat(currentUser.uid, "/").concat(testObj.id);
            return (0, FirebaseUtils_1.setNode)(tarPath, testObj)
                .then(function () {
                _this.log('cloneSharedTest# clone testObj successfully, path:', tarPath);
                _this.log('cloneSharedTest# clone testObj successfully', testObj);
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.createTest = function (test) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!test || !test.owner || test.owner.trim().length === 0) {
            return Promise.reject('createTest#, incorrect test!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        test.id = (0, uuid_1.v4)();
        this.log('createTest, test:', test);
        (0, FirebaseUtils_1.setNode)("/units/".concat(currentUser.unit, "/tests/").concat(test.owner, "/").concat(test.id), test)
            .then(function () {
            future.resolve();
        })
            .catch(function (err) {
            _this.log('createTest# err:', err);
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.getStudentCourse = function (uid) {
        if (!uid || uid === '') {
            return Promise.reject('getStudentCourse# error! Incorrect uid!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        this.getMyUnitCourses()
            .then(function (courses) {
            future.resolve(courses.filter(function (c) { return c.students && c.students.find(function (s) { return s.uid === uid; }); }));
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    CourseProviderImpl.prototype.getStudentImportTemplateUrl = function () {
        return Settings_1.Settings.SERVER_CONFIG.connections.url_student_upload_template;
    };
    CourseProviderImpl.prototype.joinCourseByCid = function (cid, student, seatNo) {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            if (_this.hybrid) {
                return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                    .queryOne('courses', {
                    cid: cid,
                    unit: student.unit
                }, {})
                    .then(function (res) {
                    return res && res.result ? res.result : undefined;
                })
                    .then(function (course) {
                    if (!course) {
                        return Promise.reject('joinCourseByCid# cannot find course by cid:' + cid);
                    }
                    return (0, FirebaseUtils_1.getNode)("/units/".concat(student.unit, "/courses/").concat(course.id)).then(function (snapshot) {
                        return snapshot.val();
                    });
                });
            }
            return _this.getMyUnitCoursesWithoutHybird().then(function (courses) {
                return courses.find(function (c) { return c.cid && c.cid === cid; });
            });
        })
            .then(function (course) {
            if (!course) {
                return Promise.reject('joinCourseByCid# cannot find course by cid:' + cid);
            }
            if (!course.students) {
                course.students = [];
            }
            if (!student.moreInfo) {
                student.moreInfo = {
                    seatNo: seatNo
                };
            }
            else {
                student.moreInfo.seatNo = seatNo;
            }
            var idx = course.students.findIndex(function (s) { return s.uid === student.uid; });
            if (idx === -1) {
                course.students.push(student);
            }
            else {
                course.students[idx] = student;
            }
            return _this.updateCourse(course);
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.removeStudent = function (course, uid) {
        if (course.students) {
            var idx = course.students.findIndex(function (s) { return s.uid === uid; });
            if (idx !== -1) {
                course.students.splice(idx, 1);
            }
        }
        return course;
    };
    CourseProviderImpl.prototype.removeStudentFromCourse = function (courseId, uid) {
        var _this = this;
        return this.getCourse(courseId)
            .then(function (course) {
            return _this.updateCourse(_this.removeStudent(course, uid));
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CourseProviderImpl.prototype.setAddByCode = function (courseId, enabled) {
        var _this = this;
        return this.getCourse(courseId)
            .then(function (course) {
            course.isAddByCode = enabled;
            return _this.updateCourse(course);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CourseProviderImpl.prototype.updateSeatNoInCourse = function (courseId, uid, seatNo) {
        var _this = this;
        return this.getCourse(courseId)
            .then(function (course) {
            if (!course.students) {
                return Promise.reject('updateSeatNoInCourse# student list is empty!');
            }
            var idx = course.students.findIndex(function (s) { return s.uid === uid; });
            if (idx === -1) {
                return Promise.reject('updateSeatNoInCourse# cannot find student:' + uid);
            }
            if (!course.students[idx].moreInfo) {
                course.students[idx].moreInfo = { seatNo: seatNo };
            }
            else {
                course.students[idx].moreInfo.seatNo = seatNo;
            }
            return _this.updateCourse(course);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    CourseProviderImpl.prototype.updateTest = function (test) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!test ||
            !test.owner ||
            test.owner.trim().length === 0 ||
            !test.id ||
            test.id.trim().length === 0) {
            return Promise.reject('Incorrect test');
        }
        var path = "/units/".concat(currentUser.unit, "/tests/").concat(currentUser.uid, "/").concat(test.id);
        return (0, FirebaseUtils_1.setNode)(path, test);
    };
    CourseProviderImpl.prototype.removeTest = function (test) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!test ||
            !test.owner ||
            test.owner.trim().length === 0 ||
            !test.id ||
            test.id.trim().length === 0) {
            return Promise.reject('Incorrect test');
        }
        var path = "/units/".concat(currentUser.unit, "/tests/").concat(currentUser.uid, "/").concat(test.id);
        return (0, FirebaseUtils_1.removeNode)(path);
    };
    CourseProviderImpl.prototype.removeShareTest = function (test, shareType) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!test ||
            !test.owner ||
            test.owner.trim().length === 0 ||
            !test.id ||
            test.id.trim().length === 0) {
            return Promise.reject('Incorrect test');
        }
        var path;
        if (shareType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/tests/").concat(test.id);
        }
        else if (shareType === 'public') {
            path = "/units/sharedResources/tests/".concat(test.id);
        }
        else {
            return Promise.reject('this share type not support!');
        }
        return (0, FirebaseUtils_1.getNode)(path).then(function (snapshot) {
            var testObj = snapshot.val();
            if (!testObj) {
                return Promise.reject('shared test not exist!');
            }
            if (currentUser.uid === 'kaydemo-airabbi-com') {
                return (0, FirebaseUtils_1.removeNode)(path);
            }
            if (!testObj.owner || testObj.owner !== currentUser.uid) {
                return Promise.reject('owner is wrong!');
            }
            return (0, FirebaseUtils_1.removeNode)(path);
        });
    };
    CourseProviderImpl.prototype.listenTest = function (courseId, testId, listener) {
        var _this = this;
        if (!courseId && courseId.trim() === '') {
            this.log('courseId cannot be empty!');
            return;
        }
        if (!testId && testId.trim() === '') {
            this.log('testId cannot be empty!');
            return;
        }
        if (!listener) {
            this.log('listener cannot be empty!');
            return;
        }
        var currentUser = (0, UserCache_1.loadUser)();
        if (!currentUser ||
            !currentUser.uid ||
            currentUser.uid.trim() === '' ||
            !currentUser.unit ||
            currentUser.unit.trim() === '') {
            return;
        }
        var path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/tests");
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var tests = snapshot.val();
            _this.log('listenTest# on# path:', path);
            _this.log('listenTest# on# tests:', tests);
            if (tests) {
                var idx = tests.findIndex(function (t) { return t.id === testId; });
                if (idx !== -1) {
                    path = "/units/".concat(currentUser.unit, "/courses/").concat(courseId, "/tests/").concat(idx, "/");
                    _this.dataSyncProvider
                        .unsubscribe(_this.nodeListenTest)
                        .then(function () {
                        var dataSyncListener = {
                            onChanged: function (data) {
                                listener.onChanged(data);
                            }
                        };
                        _this.dataSyncProvider
                            .subscribe(path, path, dataSyncListener)
                            .then(function (dataSyncNode) {
                            _this.nodeListenTest = dataSyncNode;
                        })
                            .catch(function (err) { return _this.log(err); });
                    })
                        .catch(function (err) { return _this.log(err); });
                }
                else {
                    _this.log('listenTest# cannot find test ' + testId);
                }
            }
            else {
                _this.log('listenTest# No tests in ' + courseId);
            }
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.resetTestExerciseStatus = function (courseId, testId, exerciseId) {
        var user = (0, UserCache_1.loadUser)();
        var studentInfo = {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoUri: user.photoUrl,
            seatNo: user.moreInfo && user.moreInfo.seatNo ? user.moreInfo.seatNo : ''
        };
        return this.createStudentStatus(courseId, testId, exerciseId, studentInfo);
    };
    CourseProviderImpl.prototype.unlistenCode = function (courseId, lessonId, exerciseId, userId) {
        var _this = this;
        this.log('unlistenCode#');
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            this.log('listenCode# courseId cannot be empty!');
            return;
        }
        if (!lessonId || lessonId === '') {
            this.log('listenCode# lessonId cannot be empty!');
            return;
        }
        if (!exerciseId || exerciseId === '') {
            this.log('listenCode# exerciseId cannot be empty!');
            return;
        }
        if (!userId || userId === '') {
            this.log('listenCode# userId cannot be empty!');
            return;
        }
        this.dataSyncProvider
            .unsubscribe(this.nodeListenCode)
            .then(function () {
            _this.nodeListenCode = undefined;
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.unlistenTest = function (courseId, testId) {
        var _this = this;
        if (!courseId && courseId.trim() === '') {
            this.log('unlistenTest# courseId cannot be empty!');
            return;
        }
        if (!testId && testId.trim() === '') {
            this.log('unlistenTest#testId cannot be empty!');
            return;
        }
        var currentUser = (0, UserCache_1.loadUser)();
        if (!currentUser ||
            !currentUser.uid ||
            currentUser.uid.trim() === '' ||
            !currentUser.unit ||
            currentUser.unit.trim() === '') {
            return;
        }
        this.dataSyncProvider
            .unsubscribe(this.nodeListenTest)
            .then(function () {
            _this.nodeListenTest = undefined;
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.removeCodeListener = function () {
        var _this = this;
        this.log('removeCodeListener#');
        if (!this.nodeListenCode) {
            this.log('removeCodeListener# nodeListenCode is undefined!');
            return;
        }
        this.log("removeCodeListener# path:", this.nodeListenCode);
        this.dataSyncProvider
            .unsubscribe(this.nodeListenCode)
            .then(function () {
            _this.nodeListenCode = undefined;
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.removeTestListener = function () {
        var _this = this;
        this.log('removeTestListener#');
        if (!this.nodeListenTest) {
            this.log('removeTestListener# nodeListenTest is undefined!');
            return;
        }
        this.log("removeTestListener# path:", this.nodeListenTest);
        this.dataSyncProvider
            .unsubscribe(this.nodeListenTest)
            .then(function () {
            _this.nodeListenTest = undefined;
        })
            .catch(function (err) { return _this.log(err); });
    };
    CourseProviderImpl.prototype.readCode = function (courseId, lessonId, exerciseId, userId) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId || courseId === '') {
            return Promise.reject('listenCode# courseId cannot be empty!');
        }
        if (!lessonId || lessonId === '') {
            return Promise.reject('listenCode# lessonId cannot be empty!');
        }
        if (!exerciseId || exerciseId === '') {
            return Promise.reject('listenCode# exerciseId cannot be empty!');
        }
        if (!userId || userId === '') {
            return Promise.reject('listenCode# userId cannot be empty!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "units/".concat(currentUser.unit, "/code/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(userId);
        this.log('readCode# path:', path);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            future.resolve(snapshot.val());
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    CourseProviderImpl.prototype.getTestExerciseStatus = function (courseId, testId) {
        if (!courseId || !testId) {
            return Promise.reject('getLessonExerciseStatus# error! courseId and lessonId cannot be blank!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(testId);
        this.log('getTestExerciseStatus# path:', path);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            future.resolve(snapshot.val());
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.processCourseForClone = function (course, teacher) {
        if (!course || !teacher) {
            return;
        }
        var newCourse = Object.assign({ students: [], teachers: [].push(teacher) }, course);
        if (course.students && course.students.length > 0) {
            course.students.splice(0, course.students.length);
        }
        if (course.teachers && course.teachers.length > 0) {
            var teacherTmps_1 = [];
            teacherTmps_1.push(teacher);
            course.teachers.forEach(function (teacherInDB) {
                if (teacherInDB.unit === teacher.unit) {
                    teacherTmps_1.push(teacherInDB);
                }
            });
            course.teachers = teacherTmps_1;
        }
        if (course.lessons) {
            course.lessons.forEach(function (l) {
                if (l.exercises) {
                    l.exercises.forEach(function (e) {
                        e.isShowContent = false;
                        e.creator = teacher.uid;
                        (0, FirebaseUtils_1.setNode)("units/".concat(teacher.unit, "/exercises/").concat(teacher.uid, "/").concat(e.id), e).then().catch();
                    });
                }
                if (l.offlineExercises) {
                    l.offlineExercises.forEach(function (e) {
                        e.isShowContent = false;
                        e.creator = teacher.uid;
                        (0, FirebaseUtils_1.setNode)("units/".concat(teacher.unit, "/exercises/").concat(teacher.uid, "/").concat(e.id), e).then().catch();
                    });
                }
                if (l.materials) {
                    l.materials.forEach(function (m) {
                        m.owner = teacher.uid;
                        (0, FirebaseUtils_1.setNode)("units/".concat(teacher.unit, "/materials/").concat(teacher.uid, "/").concat(m.id), m).then().catch();
                    });
                }
                if (l.openList) {
                    l.openList = [];
                }
            });
        }
        if (course.tests) {
            course.tests.forEach(function (t) {
                t.owner = teacher.uid;
                (0, FirebaseUtils_1.setNode)("units/".concat(teacher.unit, "/tests/").concat(teacher.uid, "/").concat(t.id), t).then().catch();
            });
            course.tests.forEach(function (t) {
                if (t.exercises) {
                    t.exercises.forEach(function (e) {
                        e.isShowContent = false;
                        e.creator = teacher.uid;
                        (0, FirebaseUtils_1.setNode)("units/".concat(teacher.unit, "/exercises/").concat(teacher.uid, "/").concat(e.id), e).then().catch();
                    });
                }
                if (t.offlineExercises) {
                    t.offlineExercises.forEach(function (e) {
                        e.isShowContent = false;
                        e.creator = teacher.uid;
                        (0, FirebaseUtils_1.setNode)("units/".concat(teacher.unit, "/exercises/").concat(teacher.uid, "/").concat(e.id), e).then().catch();
                    });
                }
            });
        }
    };
    CourseProviderImpl.prototype.getSharedCourses = function (codeType, sharedType, uid) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/courses");
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/courses";
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        this.log('getSharedCourses# path:', path);
        if (codeType === 'all') {
            return (0, FirebaseUtils_1.getNode)(path)
                .then(function (snapshot) { return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot)); })
                .catch(function (err) { return Promise.reject(err); });
        }
        return (0, FirebaseUtils_1.queryNode)(path, 'codeType', codeType)
            .then(function (snapshot) {
            _this.log('getSharedCourses# queryNode:', snapshot.val());
            return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot));
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    CourseProviderImpl.prototype.shareCourse = function (courseObj, sharedType) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseObj || !courseObj.id || !courseObj.teachers) {
            return Promise.reject('courseObj or attrs cannot be empty!');
        }
        if (courseObj.teachers.indexOf(currentUser.uid) === -1) {
            return Promise.reject("this teacher cannot edit this course. teacher uid: ".concat(currentUser.uid));
        }
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/courses/").concat(courseObj.id);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/courses/".concat(courseObj.id);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        courseObj.sharedType = sharedType;
        return (0, FirebaseUtils_1.setNode)(path, courseObj);
    };
    CourseProviderImpl.prototype.cloneSharedCourse = function (sharedType, courseId, teacher) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!courseId) {
            return Promise.reject('materialId cannot be blank!');
        }
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/courses/").concat(courseId);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/courses/".concat(courseId);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var courseObj = snapshot.val();
            if (!courseObj) {
                return future.reject("courseObj not found! path: ".concat(path));
            }
            _this.log('cloneSharedCourse# clone courseObj:', courseObj, 'original id: ', courseId, 'new id: ', courseObj.id);
            var tarPath = "/units/".concat(currentUser.unit, "/courses/").concat(courseObj.id);
            _this.processCourseForClone(courseObj, teacher);
            return _this.createCourseByUnit(courseObj, teacher.unit)
                .then(function () {
                _this.log('cloneSharedCourse# clone courseObj successfully, path:', tarPath);
                _this.log('cloneSharedCourse# clone courseObj successfully', courseObj);
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.cloneCourse = function (srcUnit, srcCourseId, teacher) {
        var _this = this;
        if (!srcUnit || srcUnit.trim() === '') {
            return Promise.reject('cloneCourse# error! Incorrect srcUnit!');
        }
        if (!srcCourseId || srcCourseId.trim() === '') {
            return Promise.reject('cloneCourse# error! Incorrect srcCourseId!');
        }
        if (!teacher ||
            !teacher.uid ||
            teacher.uid.trim() === '' ||
            !teacher.unit ||
            teacher.unit.trim() === '') {
            return Promise.reject('cloneCourse# error! Incorrect teacher!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        if (currentUser.uid !== 'developer-airabbi-com') {
            return Promise.reject('cloneCourse# error! Permission denied!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(teacher.unit, "/courses/").concat(srcCourseId))
            .then(function (snapshot) {
            var targetCourse = snapshot.val();
            _this.log('cloneCourse# targetCourse: ', targetCourse);
            (0, FirebaseUtils_1.getNode)("/units/".concat(srcUnit, "/courses/").concat(srcCourseId))
                .then(function (snapshot2) {
                var course = snapshot2.val();
                if (targetCourse && targetCourse.teachers) {
                    course.teachers = targetCourse.teachers;
                }
                _this.log('cloneCourse# clone course:', course);
                _this.processCourseForClone(course, teacher);
                var tarPath = "units/".concat(teacher.unit, "/courses/").concat(srcCourseId);
                return _this.createCourseByUnit(course, teacher.unit)
                    .then(function () {
                    _this.log('cloneCourse# clone course successfully, path:', tarPath);
                    _this.log('cloneCourse# clone course successfully', course);
                    future.resolve(course.id);
                })
                    .catch(function (err) { return future.reject(err); });
            })
                .catch(function (err) {
                future.reject(err);
            });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    CourseProviderImpl.prototype.isCourseExisted = function (unit, courseId, uid) {
        var _this = this;
        if (!unit || unit.trim() === '') {
            return Promise.reject('isCourseExisted# error! Incorrect srcUnit!');
        }
        if (!courseId || courseId.trim() === '') {
            return Promise.reject('isCourseExisted# error! Incorrect srcCourseId!');
        }
        if (!uid || uid.trim() === '') {
            return Promise.reject('isCourseExisted# error! Incorrect teacher!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)("/units/".concat(unit, "/courses/").concat(courseId))
            .then(function (snapshot) {
            var course = snapshot.val();
            if (course && course.id) {
                var isCourseExist_1 = false;
                if (course.teachers) {
                    course.teachers.forEach(function (teacher) {
                        if (teacher.uid === uid) {
                            isCourseExist_1 = true;
                        }
                    });
                }
                future.resolve(isCourseExist_1);
            }
            else {
                future.resolve(false);
            }
        })
            .catch(function (err) {
            _this.log('isCourseExisted#', err);
            future.resolve(false);
        });
        return future.promise;
    };
    CourseProviderImpl.prototype.stopAllMonitor = function () {
    };
    CourseProviderImpl.prototype.getLintConfig = function (codeType) {
        return Promise.reject('implement in the future');
    };
    CourseProviderImpl.prototype.inspect = function (code, codeType) {
        if (!code || !code.trim()) {
            return Promise.reject('cloneCourse# error! Incorrect code!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        var user = (0, UserCache_1.loadUser)();
        if (!(0, Utils_1.isElectron)()) {
            var url = Settings_1.Settings.SERVER_CONFIG.connections.api_inspect_python;
            (0, Request_1.request)('post', url, {}, { code: code })
                .then(function (data) {
                future.resolve(JSON.parse(data.data));
            })
                .catch(function (err) { return future.reject(err); });
        }
        else {
            if (!user) {
                future.reject({ errorCode: 'userNotFound' });
                return future.promise;
            }
            (0, FirebaseUtils_1.getNode)("/kernels/desktop/".concat(user.uid, "/lintUrl"))
                .then(function (snapshot) {
                var lintUrl = snapshot.val();
                if (lintUrl) {
                    (0, Request_1.request)('post', lintUrl, {}, { code: code })
                        .then(function (data) {
                        future.resolve(JSON.parse(data.data));
                    })
                        .catch(function (err) { return future.reject(err); });
                }
                else {
                    future.reject({ errorCode: 'lintUrlNotFound' });
                }
            })
                .catch(function (err) {
                future.reject(err);
            });
        }
        return future.promise;
    };
    CourseProviderImpl.prototype.updatedStudentStatus = function (courseId, lessonId, exerciseId, codeStatus) {
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/student-status/").concat(courseId, "/").concat(lessonId, "/").concat(exerciseId, "/").concat(currentUser.uid);
        var studentStatus = {
            id: currentUser.uid,
            courseId: courseId,
            lessonId: lessonId,
            exerciseId: exerciseId,
            student: {
                displayName: currentUser.displayName ? currentUser.displayName : '',
                email: currentUser.email ? currentUser.email : '',
                photoUrl: currentUser.photoUrl ? currentUser.photoUrl : '',
                uid: currentUser.uid ? currentUser.uid : '',
                seatNo: currentUser.moreInfo && currentUser.moreInfo.seatNo ? currentUser.moreInfo.seatNo : ''
            },
            status: codeStatus,
            codeStatus: codeStatus,
            buildCount: 0,
            tipViewCount: 0,
            answerViewCount: 0,
            duration: 0,
            result: '',
            latestBuildTime: 0,
            code: '',
            output: '',
            kernel: {},
            created: Date.now(),
            updated: Date.now(),
            observed: false,
            practiceUpdated: Date.now()
        };
        return (0, FirebaseUtils_1.setNode)(path, studentStatus);
    };
    CourseProviderImpl.prototype.getDesktopKernel = function () {
        var currentUser = (0, UserCache_1.loadUser)();
        return this.findSelfKernel(currentUser.uid);
    };
    CourseProviderImpl.prototype.loadGPTMessage = function (sessionId) {
        var collection = 'GPTMessages';
        var filter = { sessionId: sessionId };
        var sort = { updated: -1 };
        var projection = undefined;
        var distinctKey = undefined;
        var skip = 0;
        var limit = 0;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).query(collection, filter, sort, projection, distinctKey, skip, limit);
    };
    CourseProviderImpl.prototype.insertGPTMessage = function (sessionId, message) {
        var value = {
            sessionId: sessionId,
            message: message
        };
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createData('GPTMessages', value);
    };
    return CourseProviderImpl;
}());
exports.CourseProviderImpl = CourseProviderImpl;
//# sourceMappingURL=CourseProviderImpl.js.map